import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { APIFactoryEndPoints } from 'src/app/common/apifactory-end-points';
import { FileService } from 'src/app/common/File-Service';
import { LocalStorageService } from 'src/app/common/LocalStorageService';
import { Color } from 'src/app/shared/models/color';
import { MakeToOrderDetails } from 'src/app/shared/models/maketoorderdetails';
import { Product } from 'src/app/shared/models/product';
import { ProductComposition } from 'src/app/shared/models/productcomposition';
import { ProductShape } from 'src/app/shared/models/productshape';
import { WebUserInfo } from 'src/app/shared/models/web-user-info';
import { WebOrderCustomizeGroupSetup } from 'src/app/shared/models/webordercustomizegroupsetup';
import { WebOrderMinimumDateTimeSetup } from 'src/app/shared/models/weborderminimumdatetimesetup';
import { CommonService } from 'src/app/shared/services/CommonService';
import { ProductService } from 'src/app/shared/services/product.service';
import { ToastService } from 'src/app/shared/services/toastr.service';
import { getWindow } from 'ssr-window';
import { StorePickupDialogComponent } from '../store-pickup-dialog/store-pickup-dialog.component';
import { PinDialogComponent } from '../pin-dialog/pin-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GoogleCustomer } from 'src/app/shared/models/googlecustomer';
import { UserService } from 'src/app/shared/services/user.service';
import { WebOrderCustomProduct } from 'src/app/shared/models/web-order-custom-product';
import { WebOrderMakeToOrderRate } from 'src/app/shared/models/web-order-make-to-order-rate';
import { Cess } from 'src/app/shared/models/cess';
import { Tax } from 'src/app/shared/models/tax';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ProductsWithWebOrderOffers } from 'src/app/shared/models/productswithweborderoffers';
import { ViewOfferSetUpDto } from 'src/app/shared/models/viewoffersetupdto';
import { OfferDetailsDialogComponent } from '../offer-details-dialog/offer-details-dialog.component';
import { OfferDialogComponent } from '../offer-dialog/offer-dialog.component';
import { BulkDiscountDto } from 'src/app/shared/models/bulkdiscountdto';
import { WebOrderLocationSetup } from 'src/app/shared/models/weborderlocationsetup';

@Component({
  selector: 'app-customize-product',
  templateUrl: './customize-product.component.html',
  styleUrls: ['./customize-product.component.scss']
})
export class CustomizeProductComponent implements OnInit {

  categorieList = [
    { name: 'photoCakes', label: 'Photo Cakes', img: 'assets/img/Photocakes.png' },
    { name: 'customCakes', label: 'Custom Cakes', img: 'assets/img/Customcakes.png' },
    { name: 'photoFrames', label: 'Photo Frames', img: 'assets/img/Photoframes.png' },
    { name: 'chocolate', label: 'Chocolate', img: 'assets/img/Chocolate.png' }
  ];

  selectedCategory: string | null = null;
  selectedCategoryName: string = '';
  displayedProducts: Product[] = [];
  selectedProduct: Product = null;
  allProductList: Product[] = [];
  createSetUpForm: UntypedFormGroup;
  currentUrl: string;
  productCompositionList: ProductComposition[] = [];
  productColorList: Color[] = [];
  productShapeList: ProductShape[] = [];
  customizeList: WebOrderCustomizeGroupSetup[] = [];
  showColor: boolean = false;
  showComposition: boolean = false;
  showShape: boolean = false;
  showDimension: boolean = false;
  makeToOrderDetailsList: MakeToOrderDetails;
  webOrderMinimumDateTimeList: WebOrderMinimumDateTimeSetup = new WebOrderMinimumDateTimeSetup();
  timeSlot2: string[][] = [];
  timeSlotAvl: string[] = [];
  todayDate: Date = new Date();
  maxDate: string;
  minTimeInHr: string;
  qty: number;
  discount: number;
  rate1: any;
  taxRate1: any;
  cessRate1: any;
  minimumQty: any;
  showUpdate: boolean = false;
  pincode: string;
  googleCustomer: GoogleCustomer;
  resp: boolean = false;
  customCakeList: WebOrderCustomProduct[] = [];
  customCake: WebOrderCustomProduct;
  createSetUpFormCustomCake: UntypedFormGroup;
  webOrderMakeToOrderRate: WebOrderMakeToOrderRate;
  productWithOffers: ProductsWithWebOrderOffers[];
  offerTypeArray: string[] = [];
  offerObj: any;
  productOffer: Product;
  discountOffer: number;
  bulkDiscountOffer: BulkDiscountDto;
  descStr: string = '';
  deliveryType: string;
  customizePhotoCakes: number[] = [1462, 807, 838, 1671, 1672, 1673];

  categories = {
    photoCakes: [],
    customCakes: [],
    photoFrames: [],
    chocolate: [],
  };

  fileInputs = []; // Number of file inputs
  files: { [key: string]: File } = {}; // Store files dynamically

  @ViewChild('productImageContainer') productImageContainer!: ElementRef;
  @ViewChild('canvasRenderer') canvasRenderer!: ElementRef<HTMLCanvasElement>;

  overlaySize = { width: 0, height: 0 };
  overlayPosition = { top: 0, left: 0 };
  rightOverlaySize = { width: 0, height: 0 };
  rightOverlayPosition = { top: 0, left: 0 };
  isCircle = true;
  selectedOverlayIndex: number = 0;
  isAgreedTermsPhoto: boolean = false;

  //Subscription
  private customizeDetailsSubcription: Subscription;
  private webOrderTimeSlotSubcription: Subscription;
  private makeToOrderSubcription: Subscription;
  private saveWebUserInfoSubscription: Subscription;
  private webOrderMinimumDateTimeSubcription: Subscription;
  private getCustomCakeImageSubscription: Subscription;
  private offerSubscription: Subscription;
  private productOfferSubscription: Subscription;
  private productDiscountSubscription: Subscription;
  private productBulkDiscountSubscription: Subscription;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private fileService: FileService,
    private localStorage: LocalStorageService,
    private apiFactory: APIFactoryEndPoints,
    private commonService: CommonService,
    private productService: ProductService,
    private toastrService: ToastService,
    public dialog: MatDialog,
    private navRoute: Router,
    private userService: UserService,
    private domSanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
    this.currentUrl = getWindow().location.hostname;
    this.googleCustomer = JSON.parse(this.localStorage.getItem("google_loggedIn_details"));
    this.onCreateSetUp();
    this.onCreateSetUpCustomCake();
    this.getAllProducts();
    this.getWebOrderCustomizeDetails();
    this.getWebOrderTimeSlotSetUpList();
  }

  onCreateSetUp() {
    this.createSetUpForm = this.formBuilder.group({
      qty: ["", Validators.required],
      composition: [""],
      color: [""],
      shape: [""],
      dimension: [""],
      deliveryDate: ["", Validators.required],
      deliveryTime: ["", Validators.required],
      note: ["", [Validators.maxLength(40)]],
      subTotal: [""],
      productPrice: [0],
      productName: [""],
      minimum_Order_Time: [""],
      basePremiumFlavourPrice: [0],
      premiumFlavourPrice: [0]
    });

    // Add controls for multiple images dynamically
    // this.fileInputs.forEach((_, i) => {
    //   this.createSetUpForm.addControl('fileImage' + i, this.formBuilder.control(null));
    // });
  }

  getAllProducts() {
    this.allProductList = this.fileService.getFileData("allProductListCustomize");
    console.log(this.allProductList)
    this.categories.photoCakes = this.allProductList
      ?.filter(e => e.customizeType === 'Photo Cakes') // Filter for Photo Cakes
      .sort((a, b) => {
        // Define the order for sorting
        const order = ['Mini', 'Medium', 'Large'];

        // Find the index of the keywords in the product names
        const aIndex = order.findIndex(keyword => a.product_Name.includes(keyword));
        const bIndex = order.findIndex(keyword => b.product_Name.includes(keyword));

        // Sort by the found index (products not matching will be sorted to the end)
        return (aIndex !== -1 ? aIndex : order.length) - (bIndex !== -1 ? bIndex : order.length);
      });
    this.categories.photoFrames = this.allProductList?.filter(e => e.customizeType == 'Photo Frames');
    this.categories.chocolate = this.allProductList?.filter(e => e.customizeType == 'Chocolate');
    this.getOfferDetails();
  }

  getOfferDetails() {
    let productId: number[] = this.allProductList.map(element => element.product_Code);
    if (productId.length === 0) return;

    let type = this.deliveryType ? (this.deliveryType === 'storePickup' ? 'Pickup' : 'Delivery') : null;

    if (!type) {
      this.fetchOfferDetails(this.getLocationId(), productId);
      return;
    }

    this.offerSubscription = this.productService.getOfferAllowFor(
      this.apiFactory.getOfferAllowFor,
      this.currentUrl,
      type
    ).subscribe((data: string) => {
      if (data === 'Not Available') {
        console.log("No offers available.");
        return;
      }

      let locId = data === 'allowForWebsite'
        ? this.googleCustomer?.locationCode || 0
        : data === 'allowForLocation'
          ? this.getLocationId()
          : 0;

      this.fetchOfferDetails(locId, productId);
    });
  }

  fetchOfferDetails(locId: number, productId: number[]) {
    this.offerSubscription = this.productService.getOfferDetails(
      this.apiFactory.getOfferDetails,
      locId,
      productId,
      this.currentUrl
    ).subscribe((data: any) => {
      this.productWithOffers = data;
      console.log(this.productWithOffers);

      this.offerTypeArray = [];

      this.productWithOffers.forEach(element => {
        element.offerDetails.forEach(offerDetails => {
          if (!this.offerTypeArray.includes(offerDetails.schemeType)) {
            this.offerTypeArray.push(offerDetails.schemeType);
          }
        });
      });

      this.allProductList.forEach(element => {
        let offerData = this.productWithOffers.find(offer => offer.productCode === element.product_Code);
        if (offerData) {
          element.offerDetails = offerData.offerDetails;
          element.offers = offerData.offers;
        }
      });

      console.log(this.allProductList);
    });
  }

  getLocationId(): number {
    return JSON.parse(this.localStorage.getItem('location_code')) || 0;
  }

  viewOfferDetail(offers: ViewOfferSetUpDto[]) {
    console.log(offers);
    let dialogRef = this.dialog.open(OfferDetailsDialogComponent, {
      width: '550px',
      minHeight: '18%',
      maxWidth: '90%',
      maxHeight: '70%',
      autoFocus: false,
      data: { offerData: offers },
    });

    dialogRef.afterClosed().subscribe((res) => { });
  }

  // Method to handle category selection
  selectCategory(category: string) {
    this.selectedCategory = category;
    this.displayedProducts = this.categories[category];
    this.selectedCategoryName = this.formatCategoryName(category);
    this.selectedProduct = null;
    this.selectedTemplate = null;
    this.resetFormAndFiles();

    if (this.selectedCategoryName == 'Custom Cakes') {
      this.openStorePickupDialogCustom();
    } else if (this.selectedCategoryName == 'Chocolate') {
      this.displayedProducts.forEach((product) => {
        if (!product.templates || product.templates.length === 0) {
          if (product.product_Name.includes('Small')) {
            product.templates = [
              {
                preview: 'templates/Choco Wraper Small1.webp',
                extras: [
                  'templates/Choco Wraper1Front.webp',
                  'templates/Choco Wraper1Back.webp'
                ]
              },
              {
                preview: 'templates/Choco Wraper Small2.webp',
                extras: [
                  'templates/Choco Wraper2Front.webp',
                  'templates/Choco Wraper2Back.webp'
                ]
              },
              {
                preview: 'templates/Choco Wraper Small3.webp',
                extras: [
                  'templates/Choco Wraper3Front.webp',
                  'templates/Choco Wraper3Back.webp'
                ]
              },
              {
                preview: 'templates/Choco Wraper Small4.webp',
                extras: [
                  'templates/Choco Wraper4Front.webp',
                  'templates/Choco Wraper4Back.webp'
                ]
              },
              {
                preview: 'templates/Choco Wraper Small5.webp',
                extras: [
                  'templates/Choco Wraper5Front.webp',
                  'templates/Choco Wraper5Back.webp'
                ]
              },
              {
                preview: 'templates/Choco Wraper Small6.webp',
                extras: [
                  'templates/Choco Wraper6Front.webp',
                  'templates/Choco Wraper6Back.webp'
                ]
              },
              {
                preview: 'templates/Choco Wraper Small7.webp',
                extras: [
                  'templates/Choco Wraper7Front.webp',
                  'templates/Choco Wraper7Back.webp'
                ]
              },
              {
                preview: 'templates/Choco Wraper Small8.webp',
                extras: [
                  'templates/Choco Wraper8Front.webp',
                  'templates/Choco Wraper8Back.webp'
                ]
              },
              {
                preview: 'templates/Choco Wraper Small9.webp',
                extras: [
                  'templates/Choco Wraper9Front.webp',
                  'templates/Choco Wraper9Back.webp'
                ]
              },
              {
                preview: 'templates/Choco Wraper Small10.webp',
                extras: [
                  'templates/Choco Wraper10Front.webp',
                  'templates/Choco Wraper10Back.webp'
                ]
              }
            ];
          }
          else if (product.product_Name.includes('Large')) {
            product.templates = [
              {
                preview: 'templates/Choco Wraper Large1.webp',
                extras: [
                  'templates/Choco Wraper1Front.webp',
                  'templates/Choco Wraper1Back.webp'
                ]
              }, {
                preview: 'templates/Choco Wraper Large2.webp',
                extras: [
                  'templates/Choco Wraper2Front.webp',
                  'templates/Choco Wraper2Back.webp'
                ]
              }, {
                preview: 'templates/Choco Wraper Large3.webp',
                extras: [
                  'templates/Choco Wraper3Front.webp',
                  'templates/Choco Wraper3Back.webp'
                ]
              }, {
                preview: 'templates/Choco Wraper Large4.webp',
                extras: [
                  'templates/Choco Wraper4Front.webp',
                  'templates/Choco Wraper4Back.webp'
                ]
              }, {
                preview: 'templates/Choco Wraper Large5.webp',
                extras: [
                  'templates/Choco Wraper5Front.webp',
                  'templates/Choco Wraper5Back.webp'
                ]
              }, {
                preview: 'templates/Choco Wraper Large6.webp',
                extras: [
                  'templates/Choco Wraper6Front.webp',
                  'templates/Choco Wraper6Back.webp'
                ]
              }, {
                preview: 'templates/Choco Wraper Large7.webp',
                extras: [
                  'templates/Choco Wraper7Front.webp',
                  'templates/Choco Wraper7Back.webp'
                ]
              }, {
                preview: 'templates/Choco Wraper Large8.webp',
                extras: [
                  'templates/Choco Wraper8Front.webp',
                  'templates/Choco Wraper8Back.webp'
                ]
              }, {
                preview: 'templates/Choco Wraper Large9.webp',
                extras: [
                  'templates/Choco Wraper9Front.webp',
                  'templates/Choco Wraper9Back.webp'
                ]
              }, {
                preview: 'templates/Choco Wraper Large10.webp',
                extras: [
                  'templates/Choco Wraper10Front.webp',
                  'templates/Choco Wraper10Back.webp'
                ]
              },
            ];
          }
        }
      });


    }

    console.log(this.displayedProducts);
  }


  selectedTemplate: any = null;
  selectTemplate(template: any) {
    this.selectedTemplate = template;
    // this.createSetUpForm.get('fileImage0').reset();
    // this.isAgreedTermsPhoto = false;
    // this.textInputsTop = {};
    // this.textInputsBottom = {};
    // this.textColorTop = {};
    // this.textColorBottom = {};
    // this.textFontTop[this.selectedOverlayIndex] = '';
    // this.textFontBottom[this.selectedOverlayIndex] = '';
    // this.textColorTop[this.selectedOverlayIndex] = '#ffffff';
    // this.textColorBottom[this.selectedOverlayIndex] = '#ffffff';
    // this.cakes?.controls?.forEach((control: AbstractControl) => {
    //   const cakeFormGroup = control as FormGroup;
    //   cakeFormGroup.get('isAgreedTerms').reset();
    // });

    // // Clear the file inputs
    // this.files = {}; // Clear file objects

    // // Reset all file input fields
    // this.fileInputs.forEach((_, index) => {
    //   const fileInput = document.getElementById('image' + index) as HTMLInputElement;
    //   if (fileInput) {
    //     fileInput.value = ''; // Clear the input field
    //   }
    // });
  }

  openStorePickupDialog(product: Product) {
    let deliveryType = JSON.parse(this.localStorage.getItem('delivery_type'));
    let locId = JSON.parse(this.localStorage.getItem('location_code'));
    console.log(deliveryType)
    if (!deliveryType || !locId) {
      const dialogRef = this.dialog.open(StorePickupDialogComponent, {
        width: '300px',
        autoFocus: false,
        panelClass: 'store-dialog-container'
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log(result)
        if (result) {
          if (result === 'storePickup') {
            this.toastrService.showSuccessToast("Store changed sucessfully");
            let storeLocation: WebOrderLocationSetup = JSON.parse(this.localStorage.getItem('pickup_location'));
            this.webOrderMinimumDateTimeList.deliveryTime = storeLocation?.minOrderTime;
            this.webOrderMinimumDateTimeList.maxDeliveryTime = storeLocation?.maxOrderTime;
            this.selectProduct(product);
          } else if (result === 'delivery') {
            this.openPinChangeDialog(product);
          }
        }
      });
    } else {
      if (deliveryType === 'storePickup') {
        let storeLocation: WebOrderLocationSetup = JSON.parse(this.localStorage.getItem('pickup_location'));
        this.webOrderMinimumDateTimeList.deliveryTime = storeLocation?.minOrderTime;
        this.webOrderMinimumDateTimeList.maxDeliveryTime = storeLocation?.maxOrderTime;
        this.selectProduct(product);
      } else if (deliveryType === 'delivery') {
        this.selectProduct(product);
        // this.openPinChangeDialog(product);
      }
    }
  }

  openPinChangeDialog(product: Product) {
    this.pincode = this.localStorage.getItem("pincode_item");

    if (this.pincode == null) {
      const dialogRef = this.dialog.open(PinDialogComponent, {
        width: "300px",
        // data: product,
        panelClass: "pin-dialog-container",
      });

      dialogRef.afterClosed().subscribe((result) => {
        console.log(result)
        if (result?.result == true) {
          this.toastrService.showSuccessToast("Pin changed sucessfully");
          this.selectProduct(product);
          // window.location.reload();
        }
      });
    } else {
      this.selectProduct(product);
    }
  }

  selectProduct(product: Product) {
    this.getWebOrderTimeSlotSetUpList();
    var orderDuration = new Date();
    orderDuration.setHours(orderDuration.getHours() + Number.parseInt(this.webOrderMinimumDateTimeList?.deliveryTime?.split(":")[0]));
    orderDuration.setMinutes(orderDuration.getMinutes() + Number.parseInt(this.webOrderMinimumDateTimeList?.deliveryTime?.split(":")[1]));

    var maxOrderDuration = new Date();
    maxOrderDuration.setHours(maxOrderDuration.getHours() + Number.parseInt(this.webOrderMinimumDateTimeList?.maxDeliveryTime?.split(":")[0]));
    maxOrderDuration.setMinutes(maxOrderDuration.getMinutes() + Number.parseInt(this.webOrderMinimumDateTimeList?.maxDeliveryTime?.split(":")[1]));

    let minOrderDate = new Date();
    minOrderDate.setDate(minOrderDate.getDate() + product.minimum_Order_Time);

    this.maxDate = moment(maxOrderDuration).format("YYYY-MM-DD");
    this.selectedProduct = product;
    this.selectedProduct.maxDeliveryDate = this.maxDate;

    // Set todayDate to the later (greater) of orderDuration or minOrderDate
    this.todayDate = orderDuration > minOrderDate ? orderDuration : minOrderDate;
    this.minTimeInHr = moment(new Date()).format("hh:mm a");

    // Remove all existing file controls before adding new ones
    Object.keys(this.createSetUpForm.controls).forEach(controlName => {
      if (controlName.startsWith('fileImage')) {
        this.createSetUpForm.removeControl(controlName);
      }
    });

    // Clear fileInputs array
    this.fileInputs = [];

    // Dynamically add controls for the selected product's images
    for (let i = 0; i < this.selectedProduct.no_Of_Images; i++) {
      const controlName = 'fileImage' + i;
      this.createSetUpForm.addControl(controlName, this.formBuilder.control(null));
      this.fileInputs.push({ controlName }); // Track the new control in fileInputs
    }

    this.resetFormAndFiles();

    this.createSetUpForm.patchValue({
      productPrice: Number(this.selectedProduct.net_Sale_Price.toFixed(2)),
      productName: this.selectedProduct.product_Name,
      minimum_Order_Time: this.selectedProduct.minimum_Order_Time,
      qty: this.selectedProduct.minimum_Order_Quantity,
      subTotal: Number((this.selectedProduct.minimum_Order_Quantity * this.selectedProduct.net_Sale_Price).toFixed(2)),
      deliveryDate: this.todayDate,
      // deliveryTime: this.minTimeInHr
    });
    this.fileInputs.forEach((_, i) => {
      this.createSetUpForm.addControl('fileImage' + i, this.formBuilder.control(null));
    });
    this.descStr = this.selectedProduct.description ? "<li>" + this.selectedProduct.description.replace('. ', ".<li>") : '';
    if (['Photo Frames', 'Chocolate'].includes(this.selectedProduct.customizeType)) {
      this.showComposition = false;
      this.createSetUpForm.get('composition').clearValidators();
    } else {
      this.showComposition = true;
      this.createSetUpForm.get('composition').setValidators(Validators.required);
    }
    this.setWebOrderTimeSlotSetUpList();
    this.onRateShow(this.selectedProduct);
    // this.setMtoData(this.selectedProduct.product_Code);
    // this.saveWebUserInfo();
  }

  setWebOrderTimeSlotSetUpList() {
    this.timeSlotAvl = [];

    // Get selected and today's date
    let selectedDeliveryDate = moment(this.createSetUpForm.get("deliveryDate").value);
    let todayDate = moment(this.todayDate);

    let deliveryDateStr = selectedDeliveryDate.format("YYYY-MM-DD");
    let todayDateStr = todayDate.format("YYYY-MM-DD");

    // Use current time if today, otherwise use selected time
    let deliveryTime = deliveryDateStr === todayDateStr
      ? todayDate.format("HH:mm") // Use current time if today
      : selectedDeliveryDate.format("HH:mm");

    // Convert deliveryTime into total minutes
    let [hour, minute] = deliveryTime.split(":").map(Number);
    let totTime = hour * 60 + minute;

    // If delivery is today, filter only future slots
    if (deliveryDateStr === todayDateStr) {
      this.timeSlotAvl = this.timeSlot2
        .filter(([fromTime]) => {
          let [slotHour, slotMinute] = fromTime.split(":").map(Number);
          return totTime < slotHour * 60 + slotMinute;
        })
        .map(([fromTime, toTime]) => `${fromTime}-${toTime}`);
    } else {
      // Show all slots for future dates
      this.timeSlotAvl = this.timeSlot2.map(([fromTime, toTime]) => `${fromTime}-${toTime}`);
    }

    // Ensure UI updates
    this.timeSlotAvl = [...this.timeSlotAvl];
  }

  dateChanged() {
    this.createSetUpForm.get("deliveryTime").reset();
    this.setWebOrderTimeSlotSetUpList();
  }

  onRateShow(product: Product) {
    console.log(product);
    this.rate1 = Number(product.net_Sale_Price);
    this.taxRate1 = product.tax.taxRate;
    this.cessRate1 = product.cess.cessRate;
    this.minimumQty = product.minimum_Order_Quantity;
  }

  setMtoData(id: number) {
    const products: Product[] = JSON.parse(this.localStorage.getItem("avct_item"));

    if (products.some((temp) => temp.product_Code == id && temp.cartProductType == "Make To Order")) {
      let itemIndex = products.findIndex((item) => item.product_Code == id);
      this.showUpdate = true;

      this.createSetUpForm.patchValue({
        qty: products[itemIndex].orderQuantityKgs,
        deliveryDate: products[itemIndex].deliveryDate,
        deliveryTime: products[itemIndex].deliveryTime,
        color: Number(products[itemIndex].color),
        shape: Number(products[itemIndex].shape),
        composition: Number(products[itemIndex].composition),
        dimension: products[itemIndex].dimension,
        note: products[itemIndex].note,
        basePremiumFlavourPrice: products[itemIndex].basePremiumFlavourPrice,
        premiumFlavourPrice: Number(products[itemIndex].premiumFlavourPrice.toFixed(2)),
        subTotal: products[itemIndex].orderQuantityKgs * (products[itemIndex].net_Sale_Price + products[itemIndex].premiumFlavourPrice),
      });
    }
  }

  getWebOrderCustomizeDetails() {
    this.createSetUpForm.get('composition').clearValidators();
    this.customizeDetailsSubcription = this.productService.getWebOrderCustomizeList(this.currentUrl).subscribe((data) => {
      this.customizeList = data;
      console.log(this.customizeList);
      this.customizeList.forEach((element) => {
        if (element.customizableParameter == "Product Color" && element.allowCustomize == 1) {
          this.showColor = true;
        }
        if (element.customizableParameter == "Product Composition" && element.allowCustomize == 1) {
          this.showComposition = true;
          this.createSetUpForm.get('composition').setValidators(Validators.required);
        }
        if (element.customizableParameter == "Product Dimension" && element.allowCustomize == 1) {
          this.showDimension = true;
        }
        if (element.customizableParameter == "Product Shape" && element.allowCustomize == 1) {
          this.showShape = true;
        }
      });
      this.getMakeToOrderDetails();
    });
  }

  getMakeToOrderDetails() {
    this.makeToOrderSubcription = this.productService.getMakeToOrderList(this.currentUrl).subscribe((data) => {
      this.makeToOrderDetailsList = data;
      this.productCompositionList = data.productCompositions;
      this.productColorList = data.colors;
      this.productShapeList = data.productShapes;
      this.webOrderMakeToOrderRate = data.webOrderMakeToOrderRate;
      console.log(data);
    });
  }

  getWebOrderTimeSlotSetUpList() {
    let deliveryType = JSON.parse(this.localStorage.getItem("delivery_type"));
    let storeLocation = JSON.parse(this.localStorage.getItem('pickup_location'));

    if (deliveryType) {
      // Reset time slots
      this.timeSlotAvl = [];
      this.timeSlot2 = [];

      const apiUrl = deliveryType === 'storePickup' ? this.apiFactory.getTimeSlotDetailsByUrlAndLocId : this.apiFactory.getTimeSlotDetailsByUrl;
      const locId = deliveryType === 'storePickup' ? storeLocation?.locationCode : null;
      this.webOrderTimeSlotSubcription = this.productService.getTimeSlotList(apiUrl, this.currentUrl, locId)
        .subscribe((data) => {
          // Populate available slots
          this.timeSlot2 = data.map((element) => [element.fromTime, element.toTime]);

          let selectedDeliveryDate = moment(this.createSetUpForm.get("deliveryDate").value);
          let todayDate = moment(this.todayDate);

          let deliveryDateStr = selectedDeliveryDate.format("YYYY-MM-DD");
          let todayDateStr = todayDate.format("YYYY-MM-DD");

          // Use current time if today, otherwise use selected time
          let deliveryTime = deliveryDateStr === todayDateStr
            ? todayDate.format("HH:mm") // Use current time if today
            : selectedDeliveryDate.format("HH:mm");

          // Convert deliveryTime into total minutes
          let [hour, minute] = deliveryTime.split(":").map(Number);
          let totTime = hour * 60 + minute;

          if (deliveryDateStr === todayDateStr) {
            // Filter only future slots for today
            this.timeSlotAvl = this.timeSlot2
              .filter(([fromTime]) => {
                let [slotHour, slotMinute] = fromTime.split(":").map(Number);
                return totTime < slotHour * 60 + slotMinute;
              })
              .map(([fromTime, toTime]) => `${fromTime}-${toTime}`);

            // If no slots available today, move to next day
            if (this.timeSlotAvl.length === 0) {
              selectedDeliveryDate.add(1, 'day'); // Add 1 day
              this.createSetUpForm.get("deliveryDate").setValue(selectedDeliveryDate.format("YYYY-MM-DD"));

              // For next day, show all slots
              this.timeSlotAvl = this.timeSlot2.map(([fromTime, toTime]) => `${fromTime}-${toTime}`);
            }
          } else {
            // Show all slots for future dates
            this.timeSlotAvl = this.timeSlot2.map(([fromTime, toTime]) => `${fromTime}-${toTime}`);
          }

          // Ensure UI updates
          this.timeSlotAvl = [...this.timeSlotAvl];
          this.getWebOrderMinimumDateTimeDetails();
        });
    }
  }

  getWebOrderMinimumDateTimeDetails() {
    this.webOrderMinimumDateTimeSubcription = this.productService.getWebOrderMinimumDateTimeDetails(this.currentUrl).subscribe((data) => {
      this.webOrderMinimumDateTimeList = data;
      var maxOrderDuration = new Date();
      maxOrderDuration.setHours(maxOrderDuration.getHours() + Number.parseInt(this.webOrderMinimumDateTimeList?.maxDeliveryTime?.split(":")[0]));
      maxOrderDuration.setMinutes(maxOrderDuration.getMinutes() + Number.parseInt(this.webOrderMinimumDateTimeList?.maxDeliveryTime?.split(":")[1]));

      this.maxDate = moment(new Date(maxOrderDuration)).format("YYYY-MM-DD");
      // this.selectedProduct.maxDeliveryDate = this.maxDate;
      if (this.googleCustomer) {
        this.getCustomCakeByEmail();
      }
    });
  }

  // Utility method to format the category name
  formatCategoryName(category: string): string {
    switch (category) {
      case 'photoCakes':
        return 'Photo Cakes';
      case 'customCakes':
        return 'Custom Cakes';
      case 'photoFrames':
        return 'Photo Frames';
      case 'chocolate':
        return 'Chocolate';
      default:
        return '';
    }
  }

  onQtySelect(event: any) {
    this.discount = 0;
    this.qty = Number(event.target.value);

    if (this.qty < this.minimumQty) {
      this.qty = this.minimumQty;
      this.toastrService.showErrorToast("Minimum order quantity - " + this.minimumQty + this.selectedProduct.product_Unit);
    } else if (this.selectedCategory == 'chocolate' && (this.qty - this.minimumQty) % this.selectedProduct.retail_Rol !== 0) {
      const remainder = (this.qty - this.minimumQty) % this.selectedProduct.retail_Rol;
      const nextValidQty = this.qty + (this.selectedProduct.retail_Rol - remainder); // round up to next multiple
      this.qty = nextValidQty;
      this.toastrService.showWarningToast(
        `Quantity must be in multiples of ${this.selectedProduct.retail_Rol} starting from ${this.minimumQty}. Adjusted to ${nextValidQty}.`
      );
    }

    this.createSetUpForm.get("qty").setValue(this.qty);

    const rate: number = this.rate1;
    const premiumFlavourPrice: number = this.createSetUpForm.get("premiumFlavourPrice").value;
    const subTotal: number = this.qty * (Number(rate) + Number(premiumFlavourPrice));
    const subTot = Number(subTotal.toFixed(2));

    this.createSetUpForm.patchValue({ subTotal: subTot });
    this.onDiscountSelect(this.discount);
  }


  increaseQty() {
    let currentQty = Number(this.createSetUpForm.get("qty").value) || 0;
    currentQty += Number(this.selectedProduct.retail_Rol);
    this.createSetUpForm.get("qty").setValue(currentQty);
    this.onQtySelect({ target: { value: currentQty } }); // trigger calculation
  }

  decreaseQty() {
    let currentQty = Number(this.createSetUpForm.get("qty").value) || 0;
    currentQty -= Number(this.selectedProduct.retail_Rol);

    if (currentQty < this.minimumQty) {
      currentQty = this.minimumQty;
      this.toastrService.showErrorToast("Minimum order quantity - " + this.minimumQty + this.selectedProduct.product_Unit);
    }

    this.createSetUpForm.get("qty").setValue(currentQty);
    this.onQtySelect({ target: { value: currentQty } }); // trigger calculation
  }

  onDiscountSelect(discount: number) {
    // let subTotal = this.calculationSetUpForm.get('subTotal').value;
    // let taxRate = this.calculationSetUpForm.get('taxrate').value;
    // let cessRate = this.calculationSetUpForm.get('cessrate').value;

    let subTotal = this.createSetUpForm.get("subTotal").value;
    let taxRate = this.taxRate1;
    let cessRate = this.cessRate1;

    let discountAmount = discount;
    let taxableAmount = subTotal - discountAmount;
    let taxAmount = (taxRate / 100) * taxableAmount;
    let cessAmount = (cessRate / 100) * taxableAmount;
    let netAmount = taxableAmount + taxAmount + cessAmount;

    // this.calculationSetUpForm.patchValue({
    //   discountAmt: discountAmt,
    //   taxableAmt: taxableAmt,
    //   taxAmt: taxAmt,
    //   cessAmt: cessAmt,
    //   netAmt: netAmt
    // })
  }

  onFlavourSelect(name: any) {
    let premiumPrice = 0;
    let basePremiumPrice = 0;
    if (name) {
      basePremiumPrice = this.productCompositionList.filter((e) => e.refNo == name)[0].premiumFlavourPrice;
      premiumPrice = basePremiumPrice + (this.taxRate1 / 100) * basePremiumPrice + (this.cessRate1 / 100) * basePremiumPrice;
    }
    this.createSetUpForm.get("basePremiumFlavourPrice").setValue(Number(basePremiumPrice));
    this.createSetUpForm.get("premiumFlavourPrice").setValue(Number(premiumPrice.toFixed(2)));
    let rate: number = this.rate1;
    let qty: number = this.createSetUpForm.get("qty").value;
    let premiumFlavourPrice: number = this.createSetUpForm.get("premiumFlavourPrice").value;
    let subTotal: number = qty * (Number(rate) + Number(premiumFlavourPrice));
    let subTot = Number(subTotal.toFixed(2));
    this.createSetUpForm.get("subTotal").setValue(subTot);
  }

  triggerFileInput(fileInputId: string): void {
    if (!this.isAgreedTermsPhoto) {
      this.toastrService.showErrorToast('Please agree to the terms and conditions');
      return;
    }
    const fileInput = document.getElementById(fileInputId) as HTMLInputElement;
    if (fileInput) {
      fileInput.click(); // Trigger the file input click event
    }

  }

  onChangeUploadFile1(event: any, fileControl: string, imageId: string): void {
    const file = event.target.files[0];
    if (file) {
      if (file.size > 10485760)
        this.toastrService.showErrorToast("10Mb Max File Size..");
      else {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
          let result = (<FileReader>event.target).result;
          this.files[fileControl] = file; // Save file
          this.createSetUpForm.get(fileControl).setValue(result); // Optional: Save file in the form
        }
      }
    }
  }

  getFileData(fileControl: string): any {
    if (!this.createSetUpForm?.get(fileControl)?.value) {
      return false;
    } else {
      return this.createSetUpForm?.get(fileControl)?.value;
    }
  }

  onRemoveFileClick(fileControl: string, imageId: string): void {
    this.createSetUpForm.get(fileControl).setValue(null);
    this.useProcessedImage = {};
    this.processedOverlayImages = {};
    this.originalOverlayImages = {};
    delete this.files[fileControl]; // Remove file from stored files
    const fileInput = document.getElementById(imageId) as HTMLInputElement;
    if (fileInput) {
      fileInput.value = ''; // Clear input field
    }
  }

  resetFormAndFiles(): void {
    // Reset the form fields
    this.createSetUpForm.reset();
    this.selectedTemplate = null;
    this.useProcessedImage = {}; // Reset to an empty object
    this.processedOverlayImages = {}; // Reset to an empty object
    this.originalOverlayImages = {};
    this.textInputsTop = {};
    this.textInputsBottom = {};
    this.textFontTop[this.selectedOverlayIndex] = '';
    this.textFontBottom[this.selectedOverlayIndex] = '';
    this.textColorTop[this.selectedOverlayIndex] = '#ffffff';
    this.textColorBottom[this.selectedOverlayIndex] = '#ffffff';

    // Reset other fields and flags
    this.isAgreedTermsPhoto = false;
    this.cakes?.controls?.forEach((control: AbstractControl) => {
      const cakeFormGroup = control as FormGroup;
      cakeFormGroup.get('isAgreedTerms').reset();
    });

    // Clear the file inputs
    this.files = {}; // Clear file objects

    // Reset all file input fields
    this.fileInputs.forEach((_, index) => {
      const fileInput = document.getElementById('image' + index) as HTMLInputElement;
      if (fileInput) {
        fileInput.value = ''; // Clear the input field
      }
    });
  }


  async addToCart(product: Product, goToCartPage: boolean) {
    console.log(this.createSetUpForm);

    if (this.createSetUpForm.invalid || Object.keys(this.files).length < 1) {
      this.toastrService.showErrorToast("Invalid form");
      return;
    }

    // Set up product details from the form
    product.cartProductType = "Make To Order";
    product.subTotal = this.createSetUpForm.get("subTotal").value;
    product.orderQuantityKgs = this.createSetUpForm.get("qty").value;
    product.deliveryDate = moment(this.createSetUpForm.get("deliveryDate").value).format("YYYY-MM-DD");
    product.deliveryTime = this.createSetUpForm.get("deliveryTime").value;
    product.color = this.createSetUpForm.get("color").value;
    product.shape = this.createSetUpForm.get("shape").value;
    product.composition = this.createSetUpForm.get("composition").value;
    product.dimension = this.createSetUpForm.get("dimension").value;
    product.note = this.createSetUpForm.get("note").value;
    product.minimum_Order_Time = this.createSetUpForm.get("minimum_Order_Time").value;
    product.basePremiumFlavourPrice = this.createSetUpForm.get("basePremiumFlavourPrice").value;
    product.premiumFlavourPrice = this.createSetUpForm.get("premiumFlavourPrice").value;

    // Step 1: Generate combined image (for cart display)
    const finalImage = await this.generateFinalImage();
    product.customizedImage = finalImage;

    // Step 2: Create file objects for each uploaded file (and handle background-removed images)
    const fileArray = Object.keys(this.files).map(key => {
      const index = parseInt(key.replace('fileImage', ''), 10);
      const file = this.files[key];
      // If the processed image is set to true, use the processed image
      if (this.useProcessedImage[index]) {
        // Use the processed (background-removed) image if available
        return this.processedOverlayImages[index] ? this.base64ToFile(this.processedOverlayImages[index], file.name) : file;
      }
      return file; // Default to the original uploaded file
    });

    const timestamp = Date.now();
    const fileNames = fileArray.map((file, index) => {
      const productName = product.product_Name;
      const fileExtension = '.jpg';
      return `${productName}_${index}_${timestamp}${fileExtension}`;
    });

    const updatedFileArray = fileArray.map((file, index) => {
      const newFileName = fileNames[index];
      return new File([file], newFileName, { type: file.type });
    });

    // Step 3: Add finalImage as the last file (converted from base64)
    if (finalImage) {
      const productName = product.product_Name;
      const finalIndex = fileNames.length;
      const finalFileName = `${productName}_${finalIndex}_${timestamp}.jpg`;

      // Convert base64 to Blob for the final image
      const res = await fetch(finalImage);
      const blob = await res.blob();
      const finalFile = new File([blob], finalFileName, { type: 'image/jpg' });

      updatedFileArray.push(finalFile);
      fileNames.push(finalFileName);
    }

    // Step 3.5: Add left-side image (from template + overlay)
    if (product.customizeType == 'Chocolate') {
      const leftSideImage = await this.generateLeftSideFinalImage();
      if (leftSideImage) {
        const productName = product.product_Name;
        const leftSideIndex = fileNames.length; // continue from the last index
        const leftSideFileName = `${productName}_${leftSideIndex}_${timestamp}.jpg`;

        const resLeft = await fetch(leftSideImage);
        const blobLeft = await resLeft.blob();
        const leftSideFinalFile = new File([blobLeft], leftSideFileName, { type: 'image/jpg' });

        updatedFileArray.push(leftSideFinalFile);
        fileNames.push(leftSideFileName);
      }
    }

    // Step 4: Save filenames into product
    product.fileNames = fileNames;

    console.log(product);
    console.log(updatedFileArray);

    // Step 5: Continue to delivery dialog
    this.openDeliveryTypeDialog(product, goToCartPage, updatedFileArray);
  }

  async generateLeftSideFinalImage(): Promise<string> {
    return new Promise((resolve, reject) => {
      const baseImage = new Image();
      baseImage.crossOrigin = 'anonymous';
      baseImage.src = '../../../../assets/img/' + this.selectedTemplate.preview;

      baseImage.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = baseImage.naturalWidth;
        canvas.height = baseImage.naturalHeight;

        ctx.drawImage(baseImage, 0, 0, canvas.width, canvas.height);

        const overlayImgSrc = this.getOverlayImage(this.selectedOverlayIndex);
        const overlayImage = new Image();
        overlayImage.crossOrigin = 'anonymous';
        overlayImage.src = overlayImgSrc;

        overlayImage.onload = () => {
          const style = this.getStyleForImage(this.selectedOverlayIndex);
          const baseImgElement = document.querySelector('.template-base') as HTMLImageElement;

          if (!baseImgElement) {
            resolve(canvas.toDataURL('image/jpg', 0.8));
            return;
          }

          const renderedWidth = baseImgElement.clientWidth;
          const renderedHeight = baseImgElement.clientHeight;

          const xRatio = parseFloat(style.left || '0') / renderedWidth;
          const yRatio = parseFloat(style.top || '0') / renderedHeight;
          const wRatio = parseFloat(style.width || '100') / renderedWidth;
          const hRatio = parseFloat(style.height || '100') / renderedHeight;

          const x = xRatio * canvas.width;
          const y = yRatio * canvas.height;
          const w = wRatio * canvas.width;
          const h = hRatio * canvas.height * 0.8;

          ctx.drawImage(overlayImage, x, y, w, h);

          // Draw right-side small overlay (same image, different position)
          const rightStyle = this.getStyleForRightImage(this.selectedOverlayIndex);

          const rxRatio = parseFloat(rightStyle.left || '0') / renderedWidth;
          const ryRatio = parseFloat(rightStyle.top || '0') / renderedHeight;
          const rwRatio = parseFloat(rightStyle.width || '100') / renderedWidth;
          const rhRatio = parseFloat(rightStyle.height || '100') / renderedHeight;

          const rx = rxRatio * canvas.width;
          const ry = ryRatio * canvas.height;
          const rw = rwRatio * canvas.width;
          const rh = rhRatio * canvas.height * 0.8;

          ctx.drawImage(overlayImage, rx, ry, rw, rh);

          // TOP TEXT
          const topText = this.textInputsTop[this.selectedOverlayIndex] || '';
          const topFont = this.textFontTop[this.selectedOverlayIndex] || 'Arial';
          const topColor = this.textColorTop[this.selectedOverlayIndex] || '#ffffff';
          const maxTopFontSize = h * 0.10;
          let topFontSize = maxTopFontSize;
          ctx.font = `bold ${topFontSize}px ${topFont}`;
          let topTextWidth = ctx.measureText(topText).width;

          if (topTextWidth > w) {
            topFontSize = (w / topTextWidth) * topFontSize;
            ctx.font = `bold ${topFontSize}px ${topFont}`;
          }
          ctx.fillStyle = topColor;
          ctx.textAlign = 'center';
          ctx.fillText(topText, x + w / 2, y + topFontSize * -0.60); // slight upward shift

          // BOTTOM TEXT
          const bottomText = this.textInputsBottom[this.selectedOverlayIndex] || '';
          const bottomFont = this.textFontBottom[this.selectedOverlayIndex] || 'Arial';
          const bottomColor = this.textColorBottom[this.selectedOverlayIndex] || '#ffffff';
          const maxBottomFontSize = h * 0.10;
          let bottomFontSize = maxBottomFontSize;
          ctx.font = `bold ${bottomFontSize}px ${bottomFont}`;
          let bottomTextWidth = ctx.measureText(bottomText).width;

          if (bottomTextWidth > w) {
            bottomFontSize = (w / bottomTextWidth) * bottomFontSize;
            ctx.font = `bold ${bottomFontSize}px ${bottomFont}`;
          }
          ctx.fillStyle = bottomColor;
          ctx.textAlign = 'center';
          const btm = this.selectedProduct.product_Name.includes('Small') ? -1.18 : -1.00;
          ctx.fillText(bottomText, x + w / 2, y + h - bottomFontSize * btm); // near bottom



          // // ✅ Draw Top Text
          // const topText = this.textInputsTop[this.selectedOverlayIndex] || '';
          // const topFont = this.textFontTop[this.selectedOverlayIndex] || 'Arial';
          // const topColor = this.textColorTop[this.selectedOverlayIndex] || '#ffffff';
          // ctx.font = `bold ${Math.floor(h * 0.12)}px ${topFont}`;
          // ctx.fillStyle = topColor;
          // ctx.textAlign = 'center';
          // ctx.fillText(topText, x + w / 2, y + h * -0.04);

          // // ✅ Draw Bottom Text
          // const bottomText = this.textInputsBottom[this.selectedOverlayIndex] || '';
          // const bottomFont = this.textFontBottom[this.selectedOverlayIndex] || 'Arial';
          // const bottomColor = this.textColorBottom[this.selectedOverlayIndex] || '#ffffff';
          // ctx.font = `bold ${Math.floor(h * 0.12)}px ${bottomFont}`;
          // ctx.fillStyle = bottomColor;
          // ctx.textAlign = 'center';
          // ctx.fillText(bottomText, x + w / 2, y + h * 1.12);

          resolve(canvas.toDataURL('image/jpg', 0.8));
        };

        overlayImage.onerror = () => resolve(canvas.toDataURL('image/jpg', 0.8));
      };

      baseImage.onerror = () => reject('Base image failed to load');
    });
  }






  openDeliveryTypeDialog(product: Product, goToCartPage: boolean, files?: File[]) {
    let deliveryType = JSON.parse(this.localStorage.getItem('delivery_type'));
    let locId = JSON.parse(this.localStorage.getItem('location_code'));
    console.log('Delivery Type:', deliveryType, 'Location ID:', locId);
    if (!deliveryType || !locId) {
      const dialogRef = this.dialog.open(StorePickupDialogComponent, {
        width: '300px',
        autoFocus: false,
        panelClass: 'store-dialog-container'
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log(result)
        if (result) {
          if (result === 'storePickup') {
            this.setStorePickup(product, goToCartPage, files);
            // this.productService.addToCartWithFiles(product, null, files);

            // if (goToCartPage) {
            //   //Added to redirect to cart
            //   this.productService.navigateToCart(product);
            // }
          } else if (result === 'delivery') {
            this.setStorePickup(product, goToCartPage, files);
            // this.openPinDialog(product, goToCartPage, files);
          }
        }
      });
    } else {
      if (deliveryType === 'storePickup') {
        this.setStorePickup(product, goToCartPage, files);
        // this.productService.addToCartWithFiles(product, null, files);

        // if (goToCartPage) {
        //   //Added to redirect to cart
        //   this.productService.navigateToCart(product);
        // }
      } else if (deliveryType === 'delivery') {
        this.setStorePickup(product, goToCartPage, files);
        // this.openPinDialog(product, goToCartPage, files);
      }
    }
  }

  setStorePickup(product: Product, goToCartPage: boolean, files?: File[]) {
    console.log(product)
    if (product.offerDetails?.length > 0) {
      this.openOfferDialog(product, goToCartPage, files);
    } else {
      this.productService.addToCartWithFiles(product, null, files);

      if (goToCartPage) {
        this.productService.navigateToCart(product);
      }
    }
  }

  openOfferDialog(product: Product, goToCartPage: boolean, files?: File[]) {
    console.log(product);
    const cartProducts: Product[] = JSON.parse(this.localStorage.getItem("avct_item")) || [];
    let offers: ViewOfferSetUpDto[] = product.offerDetails;
    console.log(offers)
    let appliedOfferId: string = product.offerId ? product.offerId : product.offerDetails[0].offerId;
    console.log(appliedOfferId)
    const dialogRef = this.dialog.open(OfferDialogComponent, {
      width: "500px",
      height: "300px",
      data: { offers, appliedOfferId },
    });

    dialogRef.afterClosed().subscribe((offerObj) => {
      console.log(offerObj);
      if (offerObj) {
        this.offerObj = offerObj;
        //conditions
        var orderQuantity;
        var freeByProductCode;
        var cartProductType;

        if (product) {
          product.orderQuantity = product.orderQuantityKgs;
          orderQuantity = product.orderQuantity;
          freeByProductCode = product.product_Code;
          cartProductType = product.cartProductType;
        }
        console.log(product);

        if (offerObj.schemeType == "Buy 1 get 1 Free" || offerObj.schemeType == "Buy X get Y Free") {
          this.productOfferSubscription = this.productService.getProductOfferDetails(this.apiFactory.productOfferDetails, offerObj.offerId, orderQuantity)
            .subscribe(
              (data) => {
                console.log(data);
                // offer processing
                this.productOffer = data;
                console.log(offerObj)
                //set order qty as product QTY IN CART
                product.offerId = offerObj.offerId;
                this.productOffer.offerId = offerObj.offerId;
                this.productOffer.freeByProductCode = freeByProductCode;
                this.productOffer.freeProductNetSalePrice = offerObj.netSalePrice;
                this.productOffer.taxRate = offerObj.tax?.taxRate;
                this.productOffer.cessRate = offerObj.cess?.cessRate;
                this.productOffer.rate = Number((offerObj.productPriceForCustomer / (1 + (this.productOffer.taxRate / 100) + (this.productOffer.cessRate / 100))).toFixed(2));
                this.productOffer.net_Sale_Price = offerObj.productPriceForCustomer * orderQuantity;
                this.productOffer.sale_Price = this.productOffer.net_Sale_Price;
                this.productOffer.netAmountForLocation = offerObj.productPriceForLocation * orderQuantity;
                this.productOffer.orderQuantity = orderQuantity;
                this.productOffer.subTotal = this.productOffer.rate * orderQuantity;
                this.productOffer.taxableAmount = this.productOffer.subTotal;
                this.productOffer.product_Name = this.productOffer.product_Name.concat("(").concat(offerObj.schemeType).concat(")");
                this.productOffer.minimum_Order_Quantity = offerObj.minQty;
                this.productOffer.cartProductType = cartProductType;
                this.productOffer.product_Unit = this.productOffer.product_Unit;
                this.productOffer.max_Discount_Percentage = offerObj.max_Discount_Percentage;
                this.productOffer.hsn_Code = offerObj.hsnCode;
                this.productOffer.subGroupCode = offerObj.subGroupCode;

                this.productOffer.discountAmt = 0;
                this.productOffer.discountRate = 0;
                this.productOffer.product_Type = this.productOffer.product_Type;
                this.productOffer.food_Type = this.productOffer.food_Type;
                this.productOffer.deliveryDate = product.deliveryDate;
                this.productOffer.deliveryTime = product.deliveryTime;
                product.promotionOfferId = offerObj.offerId;

                console.log(product);
                console.log(this.productOffer);
                if (product.orderQuantity < offerObj.minQty && product.orderQuantity > offerObj.maxQtyPerBill) {
                  this.productService.addToCartWithFiles(product, null, files);
                  if (goToCartPage) {
                    //Added to redirect to cart
                    this.productService.navigateToCart(product);
                  }
                } else {

                  this.productService.addToCartWithFiles(product, this.productOffer, files);

                  if (goToCartPage) {
                    //Added to redirect to cart
                    this.productService.navigateToCart(product);
                  }
                }
              },
              (err) => {
                if (err.error) {
                  this.toastrService.showErrorToast(err.error.message);
                  this.productService.addToCartWithFiles(product, null, files);
                  if (goToCartPage) {
                    //Added to redirect to cart
                    this.productService.navigateToCart(product);
                  }
                }
              }
            );
        } else {
          if (offerObj.schemeType == "Buy x get x percent off") {
            this.productDiscountSubscription = this.productService.getProductDiscountDetails(this.apiFactory.productDiscountDetails, offerObj.offerId, orderQuantity)
              .subscribe(
                (data) => {
                  this.discountOffer = data;
                  console.log(this.discountOffer)
                  product.discountAmt = (this.discountOffer / 100) * product.sale_Price;
                  product.discountRate = this.discountOffer;
                  var taxableAmt = product.sale_Price - (product.sale_Price * this.discountOffer) / 100;
                  taxableAmt = taxableAmt + product.basePremiumFlavourPrice;
                  var cess = product.cess.cessRate;
                  var cessAmt = (cess / 100) * taxableAmt;
                  var cgst = (product.tax.taxRate / 2 / 100) * taxableAmt;
                  var sgst = (product.tax.taxRate / 2 / 100) * taxableAmt;
                  var tot = cgst + sgst;
                  product.promotionOfferId = offerObj.offerId;
                  product.offerId = offerObj.offerId;
                  product.taxAmount = tot; //Tax Amount
                  product.cgstAmt = cgst;
                  product.sgstAmt = sgst;
                  product.cessAmount = cessAmt;
                  product.net_Sale_Price = taxableAmt + tot + cessAmt;
                  console.log(product)
                  if (product.orderQuantity < offerObj.minQty && product.orderQuantity > offerObj.maxQtyPerBill) {
                    this.productService.addToCartWithFiles(product, null, files);
                    if (goToCartPage) {
                      //Added to redirect to cart
                      this.productService.navigateToCart(product);
                    }
                  }
                },
                (err) => {
                  if (err.error) {
                    this.toastrService.showErrorToast(err.error.message);
                    this.productService.addToCartWithFiles(product, null, files);
                    if (goToCartPage) {
                      //Added to redirect to cart
                      this.productService.navigateToCart(product);
                    }
                  }
                }
              );
          } else {
            this.productBulkDiscountSubscription = this.productService.getProductBulkDiscountDetails(this.apiFactory.productBulkOfferDetails, offerObj.offerId)
              .subscribe((data) => {
                this.bulkDiscountOffer = data;
                product.discountAmt = (this.bulkDiscountOffer.discount / 100) * product.sale_Price;
                product.discountRate = this.bulkDiscountOffer.discount;
                var taxableAmt = product.sale_Price - (product.sale_Price * this.bulkDiscountOffer.discount) / 100;
                taxableAmt = taxableAmt + product.basePremiumFlavourPrice;
                var cess = product.cess.cessRate;
                var cessAmt = (cess / 100) * taxableAmt;
                var cgst = (product.tax.taxRate / 2 / 100) * taxableAmt;
                var sgst = (product.tax.taxRate / 2 / 100) * taxableAmt;
                var tot = cgst + sgst;
                product.promotionOfferId = offerObj.offerId;
                product.offerId = offerObj.offerId;
                product.taxAmount = tot; //Tax Amount
                product.cgstAmt = cgst;
                product.sgstAmt = sgst;
                product.cessAmount = cessAmt;
                product.net_Sale_Price = taxableAmt + tot + cessAmt;
                this.productService.addToCartWithFiles(product, null, files);

                if (goToCartPage) {
                  //Added to redirect to cart
                  this.productService.navigateToCart(product);
                }
              });
          }
        }
      }
    });
  }

  openPinDialog(product: Product, goToCartPage: boolean, files?: File[]) {
    this.pincode = this.localStorage.getItem("pincode_item");
    console.log(product);

    if (this.pincode == null) {
      const dialogRef = this.dialog.open(PinDialogComponent, {
        width: "300px",
        panelClass: "pin-dialog-container",
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result?.result == true) {
          if (product.offerDetails?.length > 0) {
            this.openOfferDialog(product, goToCartPage, files);
          } else {
            this.productService.addToCartWithFiles(product, null, files);

            if (goToCartPage) {
              //Added to redirect to cart
              this.productService.navigateToCart(product);
            }
          }
          // this.productService.addToCartWithFiles(product, null, files);

          // if (goToCartPage) {
          //   //Added to redirect to cart
          //   this.productService.navigateToCart(product);
          // }
        }
      });
    } else {
      if (product.offerDetails?.length > 0) {
        this.openOfferDialog(product, goToCartPage, files);
      } else {
        this.productService.addToCartWithFiles(product, null, files);

        if (goToCartPage) {
          //Added to redirect to cart
          this.productService.navigateToCart(product);
        }
      }
      // this.productService.addToCartWithFiles(product, null, files);

      // if (goToCartPage) {
      //   //Added to redirect to cart
      //   this.productService.navigateToCart(product);
      // }
    }
  }

  saveWebUserInfo() {
    let localWebUserInfo: WebUserInfo = JSON.parse(this.localStorage.getItem("web_user_info"));
    if (localWebUserInfo) {
      localWebUserInfo.productCode = this.selectedProduct.product_Code;

      this.saveWebUserInfoSubscription = this.commonService.saveWebUserInfo(this.apiFactory.inserWebUserInfo, localWebUserInfo).subscribe((data) => {
        if (data) {
        }
      });
    }
  }

  // Custom Cake
  openStorePickupDialogCustom() {
    let deliveryType = JSON.parse(this.localStorage.getItem('delivery_type'));
    let locId = JSON.parse(this.localStorage.getItem('location_code'));
    console.log('Delivery Type:', deliveryType, 'Location ID:', locId);
    if (!deliveryType || !locId) {
      const dialogRef = this.dialog.open(StorePickupDialogComponent, {
        width: '300px',
        autoFocus: false,
        panelClass: 'store-dialog-container',
      });

      dialogRef.afterClosed().subscribe((result) => {
        console.log(result);
        if (result) {
          if (result === 'storePickup') {
            this.toastrService.showSuccessToast('Store changed successfully');
            let storeLocation: WebOrderLocationSetup = JSON.parse(this.localStorage.getItem('pickup_location'));
            this.webOrderMinimumDateTimeList.deliveryTime = storeLocation?.minOrderTime;
            this.webOrderMinimumDateTimeList.maxDeliveryTime = storeLocation?.maxOrderTime;

            this.calculateOrderDurations(result);
          } else if (result === 'delivery') {
            this.calculateOrderDurations('delivery');
            // this.openPinChangeDialogCustom();
          }
        }
      });
    } else {
      if (deliveryType === 'storePickup') {
        let storeLocation: WebOrderLocationSetup = JSON.parse(this.localStorage.getItem('pickup_location'));
        this.webOrderMinimumDateTimeList.deliveryTime = storeLocation?.minOrderTime;
        this.webOrderMinimumDateTimeList.maxDeliveryTime = storeLocation?.maxOrderTime;

        this.calculateOrderDurations('storePickup');
      } else if (deliveryType === 'delivery') {
        this.calculateOrderDurations('delivery');
        // this.openPinChangeDialogCustom();
      }
    }
  }

  openPinChangeDialogCustom() {
    this.pincode = this.localStorage.getItem('pincode_item');
    console.log(this.pincode);
    if (!this.pincode) {
      const dialogRef = this.dialog.open(PinDialogComponent, {
        width: '300px',
        panelClass: 'pin-dialog-container',
      });

      dialogRef.afterClosed().subscribe((result) => {
        console.log(result);
        if (result?.result) {
          this.toastrService.showSuccessToast('Pin changed successfully');

          this.calculateOrderDurations('delivery');
        }
      });
    } else {
      this.calculateOrderDurations('delivery');
    }
  }

  // Helper function to calculate order durations
  private calculateOrderDurations(deliveryType: string) {
    this.getWebOrderTimeSlotSetUpList();
    const { deliveryTime, maxDeliveryTime } = this.webOrderMinimumDateTimeList;

    if (!deliveryTime || !maxDeliveryTime) return;

    const getTimeOffset = (timeString: string) => {
      let [hours, minutes] = timeString.split(':').map(Number);
      return { hours: hours || 0, minutes: minutes || 0 };
    };

    // Set deliveryType in the method
    this.deliveryType = deliveryType;

    let orderDuration = new Date();
    let maxOrderDuration = new Date();

    let { hours: deliveryHours, minutes: deliveryMinutes } = getTimeOffset(deliveryTime);
    orderDuration.setHours(orderDuration.getHours() + deliveryHours);
    orderDuration.setMinutes(orderDuration.getMinutes() + deliveryMinutes);

    let { hours: maxDeliveryHours, minutes: maxDeliveryMinutes } = getTimeOffset(maxDeliveryTime);
    maxOrderDuration.setHours(maxOrderDuration.getHours() + maxDeliveryHours);
    maxOrderDuration.setMinutes(maxOrderDuration.getMinutes() + maxDeliveryMinutes);

    this.maxDate = moment(maxOrderDuration).format('YYYY-MM-DD');
    this.todayDate = orderDuration;
  }

  onCreateSetUpCustomCake() {
    this.createSetUpFormCustomCake = this.formBuilder.group({
      cakes: this.formBuilder.array([this.createCakeFormGroup()])
    });
  }

  get cakes(): FormArray {
    return this.createSetUpFormCustomCake.get('cakes') as FormArray;
  }

  createCakeFormGroup(): FormGroup {
    return this.formBuilder.group({
      refNo: [],
      email: [],
      requestedQty: ["", Validators.required],
      requestedDeliveryDate: ["", Validators.required],
      requestedDeliveryTime: ["", Validators.required],
      note: ["", [Validators.maxLength(40)]],
      responseQty: [],
      responseDeliveryDate: [],
      responseDeliveryTime: [],
      rate: [0],
      totalAmount: [0],
      status: [],
      image: [],
      fileImage: [],
      selectedImageEdit: [],
      isAgreedTerms: [],
      requestedSlots: [],
      responseSlots: [],
      minimumQty: [],
      locationCode: [],
      productCode: [],
      composition: [],
      basePremiumFlavourPrice: [0],
      premiumFlavourPrice: [0]
    });
  }

  addCake() {
    if (this.createSetUpFormCustomCake.invalid) {
      this.toastrService.showErrorToast('Invalid form');
      return;
    }
    if (this.cakes.length >= 3) {
      this.toastrService.showErrorToast('Max 3 Custom cakes allowed');
      return;
    }
    this.cakes.push(this.createCakeFormGroup());
  }

  getFileDataCustomCake(fileName: string, index: number) {
    const cakeFormGroup = this.cakes.at(index) as FormGroup;

    if (!cakeFormGroup.get(fileName)?.value) {
      return false;
    } else {
      return cakeFormGroup.get(fileName).value;
    }
  }

  onFileInputClick(event: Event, i: number) {
    const cakeFormGroup = this.cakes.at(i) as FormGroup;

    // Check if terms are agreed
    if (!cakeFormGroup.get('isAgreedTerms').value) {
      this.toastrService.showErrorToast('Please agree to the terms and conditions');

      // Prevent the file dialog from opening
      event.preventDefault();
    }
  }

  onChangeUploadFileCustomCake(event: any, imageFile: string, image: string, index: number) {
    const cakeFormGroup = this.cakes.at(index) as FormGroup;

    if (event) {
      const file = event.target.files && event.target.files[0];
      if (file) {
        if (file.size > 10485760)
          this.toastrService.showErrorToast("10Mb Max File Size..");
        else {
          var reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = (event) => {
            let result = (<FileReader>event.target).result;
            cakeFormGroup.get(imageFile).setValue(result);
            cakeFormGroup.get(image).setValue(file);
          }
        }
      }
    }
  }

  onRemoveFileClickCustomCake(file: string, image: any, index: number) {
    const cakeFormGroup = this.cakes.at(index) as FormGroup;

    cakeFormGroup.get(image).reset();
    cakeFormGroup.get(file).reset();
    const fileInputElement = document.getElementById(image) as HTMLInputElement;
    if (fileInputElement) {
      fileInputElement.value = ''; // Clear the file input value
    }
  }

  customDateChanged(index: number, type: string) {
    const cakeFormGroup = this.cakes.at(index) as FormGroup;
    if (type == 'Requested')
      cakeFormGroup.get("requestedDeliveryTime").reset();
    else
      cakeFormGroup.get("responseDeliveryTime").reset();

    this.setCustomTimeSlot(index, type);
  }

  setCustomTimeSlot(index: number, type: string) {
    const cakeFormGroup = this.cakes.at(index) as FormGroup;
    let dateType = type == 'Requested' ? 'requestedDeliveryDate' : 'responseDeliveryDate';
    let slotType = type == 'Requested' ? 'requestedSlots' : 'responseSlots';
    cakeFormGroup.get(slotType).setValue([]);

    // Get selected and today's date
    let selectedDeliveryDate = moment(cakeFormGroup.get(dateType).value);
    let todayDate = moment(this.todayDate);

    console.log(selectedDeliveryDate);
    console.log(todayDate);

    let deliveryDateStr = selectedDeliveryDate.format("YYYY-MM-DD");
    let todayDateStr = todayDate.format("YYYY-MM-DD");

    // Use current time if today, otherwise use selected time
    let deliveryTime = deliveryDateStr === todayDateStr
      ? todayDate.format("HH:mm") // Use current time if today
      : selectedDeliveryDate.format("HH:mm");

    // Convert deliveryTime into total minutes
    let [hour, minute] = deliveryTime.split(":").map(Number);
    let totTime = hour * 60 + minute;

    // If delivery is today, filter only future slots
    if (deliveryDateStr === todayDateStr) {
      cakeFormGroup.get(slotType).setValue(this.timeSlot2
        .filter(([fromTime]) => {
          let [slotHour, slotMinute] = fromTime.split(":").map(Number);
          return totTime < slotHour * 60 + slotMinute;
        })
        .map(([fromTime, toTime]) => `${fromTime}-${toTime}`));
    } else {
      // Show all slots for future dates
      cakeFormGroup.get(slotType).setValue(this.timeSlot2.map(([fromTime, toTime]) => `${fromTime}-${toTime}`));
    }

    // let currDateMto = moment(new Date(cakeFormGroup.get(dateType).value)).format("YYYY-MM-DD");
    // let currTime = moment(new Date()).format("HH:mm");
    // let hour = Number(currTime.split(":")[0]);
    // let amPm = currTime.split(" ")[1];

    // if (amPm == "pm" || amPm == "PM") {
    //   hour += 12;
    // }
    // let totTime: number = Number(hour * 60) + Number(currTime.split(":")[1].split(" ")[0]);

    // this.timeSlot2.forEach((e) => {
    //   let slotHourFrom = e[0].split(":")[0];
    //   let slotMinFrom = e[0].split(":")[1];
    //   let slotHourTo = e[1].split(":")[0];
    //   let slotMinTo = e[1].split(":")[1];

    //   let fromSlotTime = Number(slotHourFrom) * 60;
    //   let toSlotTime = Number(slotHourTo) * 60;

    //   if (currDateMto == moment(this.todayDate).format("YYYY-MM-DD")) {
    //     if (totTime >= fromSlotTime && totTime <= toSlotTime) {
    //       // let tSlot: any = slotHourFrom + ":" + slotMinFrom + "-" + slotHourTo + ":" + slotMinTo;
    //       // cakeFormGroup.get(slotType).value.push(tSlot);
    //     } else if (totTime <= fromSlotTime) {
    //       let tSlot: any = slotHourFrom + ":" + slotMinFrom + "-" + slotHourTo + ":" + slotMinTo;
    //       cakeFormGroup.get(slotType).value.push(tSlot);
    //     }
    //   } else {
    //     let tSlot = slotHourFrom + ":" + slotMinFrom + "-" + slotHourTo + ":" + slotMinTo;
    //     cakeFormGroup.get(slotType).value.push(tSlot);
    //   }
    // });
  }

  onCustomFlavourSelect(name: any, index: number) {
    const cakeFormGroup = this.cakes.at(index) as FormGroup;

    let premiumPrice = 0;
    let basePremiumPrice = 0;
    if (name) {
      basePremiumPrice = this.productCompositionList.filter((e) => e.refNo == name)[0].premiumFlavourPrice;
      premiumPrice = basePremiumPrice + (this.webOrderMakeToOrderRate.gstRate / 100) * basePremiumPrice + (this.webOrderMakeToOrderRate.cessRate / 100) * basePremiumPrice;
    }
    cakeFormGroup.get('basePremiumFlavourPrice').setValue(Number(basePremiumPrice));
    cakeFormGroup.get('premiumFlavourPrice').setValue(Number(premiumPrice.toFixed(2)));
    let rate: number = cakeFormGroup.get('rate').value;
    let qty: number = cakeFormGroup.get('responseQty').value;
    let premiumFlavourPrice: number = cakeFormGroup.get('premiumFlavourPrice').value;
    let subTotal: number = qty * (Number(rate) + Number(premiumFlavourPrice));
    let subTot = Number(subTotal.toFixed(2));
    cakeFormGroup.get("totalAmount").setValue(subTot);
  }

  openDeliveryTypeDialogForCheckPrice(index: number) {
    let googleId = JSON.parse(this.localStorage.getItem("google_id"));
    let fbId = JSON.parse(this.localStorage.getItem("fb_id"));

    if (!googleId && !fbId) {
      this.navRoute.navigate(["/login", "customized-product"]);
      return;
    }
    let deliveryType = JSON.parse(this.localStorage.getItem('delivery_type'));
    let locId = JSON.parse(this.localStorage.getItem('location_code'));
    console.log('Delivery Type:', deliveryType, 'Location ID:', locId);
    if (!deliveryType || !locId) {
      const dialogRef = this.dialog.open(StorePickupDialogComponent, {
        width: '300px',
        autoFocus: false,
        panelClass: 'store-dialog-container'
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log(result)
        if (result) {
          if (result === 'storePickup') {
            this.saveCustomCake(index);
          } else if (result === 'delivery') {
            this.saveCustomCake(index);
            // this.openPinDialogForCheckPrice(index);
          }
        }
      });
    } else {
      if (deliveryType === 'storePickup') {
        this.saveCustomCake(index);
      } else if (deliveryType === 'delivery') {
        this.saveCustomCake(index);
        // this.openPinDialogForCheckPrice(index);
      }
    }
  }

  openPinDialogForCheckPrice(index: number) {
    this.pincode = this.localStorage.getItem("pincode_item");

    if (this.pincode == null) {
      const dialogRef = this.dialog.open(PinDialogComponent, {
        width: "300px",
        panelClass: "pin-dialog-container",
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result?.result == true) {
          this.saveCustomCake(index);
        }
      });
    } else {
      this.saveCustomCake(index);
    }
  }

  saveCustomCake(index: number) {
    let locationCode = JSON.parse(this.localStorage.getItem('location_code'));
    const cakeFormGroup = this.cakes.at(index) as FormGroup;
    if (cakeFormGroup.invalid) {
      this.toastrService.showErrorToast('Invalid form');
      return;
    }

    cakeFormGroup.get('email').setValue(this.googleCustomer.email);
    cakeFormGroup.get('locationCode').setValue(locationCode);
    let formatedRequestedDate = moment(cakeFormGroup.get('requestedDeliveryDate').value).format("YYYY-MM-DD");
    cakeFormGroup.get('requestedDeliveryDate').setValue(formatedRequestedDate);
    let status = cakeFormGroup.get('status').value;
    if (status == 'Resolved') {
      cakeFormGroup.get('status').setValue('Accepted');
    } else {
      cakeFormGroup.get('status').setValue('Requested');
      cakeFormGroup.get('productCode').setValue(this.generateComplexProductCode());
    }
    let updatedFile = null;
    if (cakeFormGroup.get('status').value == 'Requested') {
      let file = cakeFormGroup.get('image').value;
      if (!file) {
        this.toastrService.showErrorToast('Choose file');
        return;
      }

      // Generate file name with timestamp and product name
      const timestamp = Date.now();
      const productName = 'CUS' + index;
      // Set file extension to .webp
      const fileExtension = '.jpg';
      // const fileExtension = file.name.substring(file.name.lastIndexOf('.'));
      const newFileName = `${productName}_${timestamp}${fileExtension}`;

      // Create a new File object with the updated name
      updatedFile = new File([file], newFileName, { type: file.type });

      cakeFormGroup.get('fileImage').setValue(updatedFile.name);
    }

    if (this.checkCustomRefNo(index)) {
      cakeFormGroup.get('requestedQty').enable({ emitEvent: false });
      cakeFormGroup.get('requestedDeliveryDate').enable({ emitEvent: false });
      cakeFormGroup.get('requestedDeliveryTime').enable({ emitEvent: false });
      cakeFormGroup.get('note').enable({ emitEvent: false });
      cakeFormGroup.get('composition').enable({ emitEvent: false });
      cakeFormGroup.get('premiumFlavourPrice').enable({ emitEvent: false });
    }

    this.userService.addCustomCakeWithFile(this.apiFactory.insertCustomProduct, cakeFormGroup, updatedFile).subscribe((data) => {
      this.toastrService.showSuccessToast("Data has been successfully saved.");
      cakeFormGroup.get('refNo').setValue(data);
      this.getCustomCakeImage(index);
      this.checkCustomRefNo(index);
    })
  }

  deleteCustomCake(index: number) {
    const cakeFormGroup = this.cakes.at(index) as FormGroup;
    let refNo: number = cakeFormGroup.get('refNo').value;

    if (refNo) {
      this.userService.deleteCustomCake(this.apiFactory.deleteCustomProduct, refNo).subscribe((data) => {
        this.toastrService.showSuccessToast('Cancellation successful.');
        this.cakes.removeAt(index);
      })
    }
    else {
      this.cakes.removeAt(index);
    }
  }

  checkCustomRefNo(index: number) {
    let formCtrl: AbstractControl = this.cakes.at(index);

    if (formCtrl.get('refNo').value) {
      formCtrl.get('requestedQty').disable();
      formCtrl.get('requestedDeliveryDate').disable();
      formCtrl.get('requestedDeliveryTime').disable();
      formCtrl.get('note').disable();
      formCtrl.get('isAgreedTerms').disable();
      formCtrl.get('composition').disable();
      formCtrl.get('premiumFlavourPrice').disable();
      formCtrl.get('responseDeliveryDate').setValidators(Validators.required);
      formCtrl.get('responseDeliveryTime').setValidators(Validators.required);
      this.resp = true;
    }
    else {
      formCtrl.get('requestedQty').enable();
      formCtrl.get('requestedDeliveryDate').enable();
      formCtrl.get('requestedDeliveryTime').enable();
      formCtrl.get('note').enable();
      formCtrl.get('isAgreedTerms').enable();
      formCtrl.get('composition').enable();
      formCtrl.get('premiumFlavourPrice').enable();
      formCtrl.get('responseDeliveryDate').clearValidators();
      formCtrl.get('responseDeliveryTime').clearValidators();
      this.resp = false;
    }
    return this.resp;
  }

  setCustomCakesValues() {
    this.cakes.reset();
    this.cakes.clear();
    console.log(this.customCakeList)

    this.customCakeList.forEach((element, index) => {
      let fg = this.createCakeFormGroup();
      fg.patchValue({
        refNo: element.refNo,
        email: element.email,
        locationCode: element.locationCode,
        requestedQty: element.requestedQty,
        requestedDeliveryDate: element.requestedDeliveryDate,
        requestedDeliveryTime: element.requestedDeliveryTime,
        note: element.note,
        responseQty: element.responseQty,
        minimumQty: element.responseQty,
        responseDeliveryDate: element.responseDeliveryDate,
        responseDeliveryTime: element.responseDeliveryTime,
        rate: element.rate,
        totalAmount: element.totalAmount,
        status: element.status,
        productCode: element.productCode,
        composition: element.composition,
        basePremiumFlavourPrice: element.basePremiumFlavourPrice,
        premiumFlavourPrice: element.premiumFlavourPrice,
        fileImage: element.fileImage,
        isAgreedTerms: true,
      })
      this.cakes.push(fg);
      this.getCustomCakeImage(index);
      this.setCustomTimeSlot(index, 'Requested');
      this.onCustomFlavourSelect(element.composition, index);
      if (element.responseDeliveryTime) {
        this.setCustomTimeSlot(index, 'Response');
      }
    });
    console.log(this.cakes)

    return this.cakes;
  }

  getCustomCakeByEmail() {
    this.userService.getCustomCakeByEmail(this.apiFactory.getCustomProductByEmail, this.googleCustomer.email).subscribe((data) => {
      if (data.length > 0) {
        this.customCakeList = data;
        this.setCustomCakesValues();
      }
    })
  }

  getCustomCakeByRefNo(index: number) {
    const cakeFormGroup = this.cakes.at(index) as FormGroup;
    let refNo: number = cakeFormGroup.get('refNo').value;
    this.userService.getCustomCakeByRefNo(this.apiFactory.getCustomProductByRefNo, refNo).subscribe((data) => {
      if (data && data.status != 'Requested') {
        this.customCake = data;
        cakeFormGroup.patchValue({
          refNo: data.refNo,
          email: data.email,
          locationCode: data.locationCode,
          requestedQty: data.requestedQty,
          requestedDeliveryDate: data.requestedDeliveryDate,
          requestedDeliveryTime: data.requestedDeliveryTime,
          note: data.note,
          responseQty: data.responseQty,
          minimumQty: data.responseQty,
          responseDeliveryDate: data.responseDeliveryDate,
          responseDeliveryTime: data.responseDeliveryTime,
          rate: data.rate,
          totalAmount: data.totalAmount,
          status: data.status,
          productCode: data.productCode,
          composition: data.composition,
          basePremiumFlavourPrice: data.basePremiumFlavourPrice,
          premiumFlavourPrice: data.premiumFlavourPrice,
          fileImage: data.fileImage,
          isAgreedTerms: true,
        })
        this.onCustomFlavourSelect(data.composition, index);
        if (data.responseDeliveryTime) {
          this.setCustomTimeSlot(index, 'Response');
        }
      } else {
        this.toastrService.showWarningToast('Please try again after some time.')
      }
    })
  }

  getCustomCakeImage(index: number) {
    const cakeFormGroup = this.cakes.at(index) as FormGroup;

    this.getCustomCakeImageSubscription = this.productService.downloadImage(this.apiFactory.getServerUrl, 'cartcustomizedproduct', cakeFormGroup.get('fileImage').value).subscribe((data) => {
      if (data.toString().includes("ArrayBuffer") == true) {
        let file = new Blob([data], { type: 'image/jpeg' });
        let fl1 = URL.createObjectURL(file);
        let fl2: SafeUrl = this.domSanitizer.bypassSecurityTrustUrl(fl1);
        cakeFormGroup.get('selectedImageEdit').setValue(fl2);
      }
    });
  }

  onResponseQtySelect(event: any, index: number) {
    const cakeFormGroup = this.cakes.at(index) as FormGroup;
    let inputQty = Number(event.target.value);
    let minimumQty = cakeFormGroup.get('minimumQty').value;
    let responseRate = cakeFormGroup.get('rate').value;

    if (inputQty >= minimumQty) {
      cakeFormGroup.get('totalAmount').setValue(inputQty * responseRate);
    } else {
      cakeFormGroup.get("responseQty").setValue(minimumQty);
      this.toastrService.showErrorToast("Minimum order quantity - " + minimumQty + "Kgs");
    }
  }

  addToCartCustomCake(index: number, goToCartPage: boolean) {
    const cakeFormGroup = this.cakes.at(index) as FormGroup;
    if (cakeFormGroup.invalid) {
      this.toastrService.showErrorToast('Invalid form');
      return;
    }
    let product: Product = new Product();
    product.product_Code = cakeFormGroup.get("productCode").value;
    product.cartProductType = "Make To Order";
    product.subMtoType = "Custom Cakes";
    product.subTotal = cakeFormGroup.get("totalAmount").value;
    product.net_Sale_Price = cakeFormGroup.get("rate").value;
    product.orderQuantityKgs = cakeFormGroup.get("responseQty").value;
    let formatedResponseDate = moment(cakeFormGroup.get('responseDeliveryDate').value).format("YYYY-MM-DD");
    product.deliveryDate = formatedResponseDate;
    product.deliveryTime = cakeFormGroup.get("responseDeliveryTime").value;
    product.composition = cakeFormGroup.get("composition").value;
    product.basePremiumFlavourPrice = cakeFormGroup.get("basePremiumFlavourPrice").value;
    product.premiumFlavourPrice = cakeFormGroup.get("premiumFlavourPrice").value;
    product.product_Picture = cakeFormGroup.get("fileImage").value;
    product.customizedProductPicture = cakeFormGroup.get("fileImage").value;
    product.note = cakeFormGroup.get("note").value;
    product.cess = new Cess();
    product.cess.cessRate = this.webOrderMakeToOrderRate.cessRate;
    product.tax = new Tax();
    product.tax.taxRate = this.webOrderMakeToOrderRate.gstRate;
    product.hsn_Code = this.webOrderMakeToOrderRate.hsnCode;
    product.max_Discount_Percentage = this.webOrderMakeToOrderRate.maxDiscountPercentage;
    product.product_Type = this.webOrderMakeToOrderRate.productType;
    product.product_Unit = this.webOrderMakeToOrderRate.productUnit;
    product.subGroupCode = this.webOrderMakeToOrderRate.subGroupCode;
    let salePrice = product.net_Sale_Price / ((product.tax.taxRate / 100) + (product.cess.cessRate / 100) + 1);
    product.sale_Price = Number(salePrice.toFixed(2));
    product.fileNames = [cakeFormGroup.get("fileImage").value];
    console.log(product);

    // Pass the updated files and product to the next method
    this.openDeliveryTypeDialog(product, goToCartPage);
  }

  generateComplexProductCode(): number {
    const timestamp = Date.now() % 1000000000; // Reducing the timestamp to fit within the range
    const randomNum = Math.floor(Math.random() * 1000000000); // Generate a random number up to 1 billion
    const uniqueCode = (timestamp ^ randomNum) % 2147483647; // XOR the values and limit it to Integer range
    return uniqueCode;
  }

  loadImage(src: string): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous'; // Needed if loading external images
      img.onload = () => resolve(img);
      img.onerror = (e) => reject(e);
      img.src = src;
    });
  }

  async generateFinalImage(): Promise<string> {
    const canvas = this.canvasRenderer.nativeElement;
    const ctx = canvas.getContext('2d');
    if (!ctx) return '';

    const container = this.productImageContainer.nativeElement.getBoundingClientRect();
    canvas.width = container.width;
    canvas.height = container.height;

    // 1. Draw base cake image
    const baseImage = await this.loadImage(`../../../../assets/img/${this.selectedProduct.product_Picture}`);
    ctx.drawImage(baseImage, 0, 0, canvas.width, canvas.height);

    // 2. Draw overlay if exists (Photo Cake Mini, Medium, Large)
    if (this.customizePhotoCakes.includes(this.selectedProduct.product_Code) &&
      !['Photo Gallery Cake'].includes(this.selectedProduct.product_Name)) {
      const overlaySrc = this.getFileData('fileImage' + this.selectedOverlayIndex);
      if (overlaySrc) {
        const overlayImage = await this.loadImage(overlaySrc);

        let finalWidth = this.overlaySize.width;
        let finalHeight = this.overlaySize.height;
        let drawX = this.overlayPosition.left;
        let drawY = this.overlayPosition.top;

        if (this.selectedProduct.customizeType === 'Photo Frames') {
          finalHeight *= 0.79;
          drawY = drawY + 2;
        } else {
          // For Photo Cakes (circle)
          finalHeight *= 0.95;
          drawY = drawY + (this.overlaySize.height - finalHeight) / 2 - 10;
        }

        const shouldClipToCircle =
          this.isCircle && this.selectedProduct.customizeType === 'Photo Cakes';

        if (shouldClipToCircle) {
          ctx.save();
          ctx.beginPath();

          const centerX = drawX + finalWidth / 2;
          const centerY = drawY + finalHeight / 2;

          const radiusX = finalWidth / 2;
          const radiusY = finalHeight / 2 * 0.92;  // Slightly less height for oval effect

          ctx.ellipse(centerX, centerY, radiusX, radiusY, 0, 0, Math.PI * 2);
          ctx.closePath();
          ctx.clip();
        }

        ctx.drawImage(overlayImage, drawX, drawY, finalWidth, finalHeight);

        if (shouldClipToCircle) {
          ctx.restore();
        }
      }
    }

    if (this.selectedProduct.product_Name === 'Photo Gallery Cake') {
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      // === 1. Center round image ===
      const centerImageSrc = this.getFileData('fileImage0');
      if (centerImageSrc) {
        const centerImage = await this.loadImage(centerImageSrc);

        // Match CSS: width: 19%, height: 23%, left: 49.5%, top: 67.5%
        const centerWidth = canvasWidth * 0.19;
        const centerHeight = canvasHeight * 0.23;
        const centerX = canvasWidth * 0.495 - centerWidth / 2;
        const centerY = canvasHeight * 0.675 - centerHeight / 2;

        ctx.save();
        ctx.beginPath();
        ctx.arc(centerX + centerWidth / 2, centerY + centerHeight / 2, Math.min(centerWidth, centerHeight) / 2, 0, Math.PI * 2);
        ctx.closePath();
        ctx.clip();

        ctx.drawImage(centerImage, centerX, centerY, centerWidth, centerHeight);
        ctx.restore();
      }

      // === 2. Top 3 garland square images ===
      const topGarlandPositions = [
        { leftPercent: 0.33, topPercent: 0.15, rotation: 18 },
        { leftPercent: 0.45, topPercent: 0.19, rotation: 6 },
        { leftPercent: 0.56, topPercent: 0.16, rotation: -4 }
      ];

      for (let i = 1; i <= 3; i++) {
        const overlaySrc = this.getFileData('fileImage' + i);
        if (overlaySrc) {
          const overlayImage = await this.loadImage(overlaySrc);
          const pos = topGarlandPositions[i - 1];

          const width = canvasWidth * 0.10;  // width: 10%
          const height = canvasHeight * 0.15; // height: 15%
          const x = canvasWidth * pos.leftPercent;
          const y = canvasHeight * pos.topPercent;

          // Apply rotation
          ctx.save();
          ctx.translate(x + width / 2, y + height / 2);
          ctx.rotate((pos.rotation * Math.PI) / 180);
          ctx.drawImage(overlayImage, -width / 2, -height / 2, width, height);
          ctx.restore();
        }
      }
    }

    if (this.selectedProduct.product_Name === 'Photo Circle') {
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      // === 1. Top 4 Round Images ===
      const topPositions = [
        { top: 0.19, left: 0.28, rotation: -34 },
        { top: 0.17, left: 0.40, rotation: 0 },
        { top: 0.07, left: 0.35, rotation: 8 },
        { top: 0.11, left: 0.23, rotation: -25 } // Adjusted rotation for better visual
      ];

      for (let i = 0; i < 4; i++) {
        const overlaySrc = this.getFileData('fileImage' + i);
        if (overlaySrc) {
          const img = await this.loadImage(overlaySrc);

          const width = canvasWidth * 0.13;
          const height = canvasHeight * 0.15;

          const x = canvasWidth * topPositions[i].left;
          const y = canvasHeight * topPositions[i].top;

          ctx.save();
          ctx.translate(x + width / 2, y + height / 2);
          ctx.rotate((topPositions[i].rotation * Math.PI) / 180);
          ctx.beginPath();
          ctx.arc(0, 0, Math.min(width, height) / 2, 0, Math.PI * 2);
          ctx.clip();
          ctx.drawImage(img, -width / 2, -height / 2, width, height);
          ctx.restore();
        }
      }

      // === 2. Middle 4 Square/Styled Images (3D-look band) ===
      const middlePositions = [
        { top: 0.57, left: 0.22, width: 0.17, height: 0.20, rotateY: -50 },
        { top: 0.60, left: 0.35, width: 0.15, height: 0.21, rotateY: 10 },
        { top: 0.60, left: 0.48, width: 0.18, height: 0.21, rotateY: -40 },
        { top: 0.57, left: 0.58, width: 0.20, height: 0.22, rotateY: -70 }
      ];

      for (let i = 0; i < 4; i++) {
        const overlaySrc = this.getFileData('fileImage' + i);
        if (overlaySrc) {
          const img = await this.loadImage(overlaySrc);

          const pos = middlePositions[i];
          const width = canvasWidth * pos.width;
          const height = canvasHeight * pos.height;
          const x = canvasWidth * pos.left;
          const y = canvasHeight * pos.top;

          // Simulate a slight skew for 3D look (canvas doesn't support rotateY, so we use shear via transform matrix if needed)
          ctx.save();
          ctx.translate(x + width / 2, y + height / 2);
          const shearX = Math.tan((pos.rotateY || 0) * Math.PI / 180) * 0.2;
          ctx.transform(1, 0, shearX, 1, 0, 0);

          ctx.beginPath();
          if (i === 1) {
            // bottom-left radius
            this.roundedRect(ctx, -width / 2, -height / 2, width, height, {
              bottomLeft: 28
            });
          } else if (i === 2) {
            // bottom-right radius
            this.roundedRect(ctx, -width / 2, -height / 2, width, height, {
              bottomRight: 26
            });
          } else if (i === 3) {
            // top-left + bottom-right
            this.roundedRect(ctx, -width / 2, -height / 2, width, height, {
              topLeft: 26,
              bottomRight: 30
            });
          } else {
            ctx.rect(-width / 2, -height / 2, width, height);
          }
          ctx.clip();
          ctx.drawImage(img, -width / 2, -height / 2, width, height);
          ctx.restore();
        }
      }
    }
    // 4. Return final image as base64
    return canvas.toDataURL('image/png');
  }

  roundedRect(ctx: CanvasRenderingContext2D, x: number, y: number, width: number, height: number, radii: any) {
    const tl = radii.topLeft || 0;
    const tr = radii.topRight || 0;
    const br = radii.bottomRight || 0;
    const bl = radii.bottomLeft || 0;

    ctx.beginPath();
    ctx.moveTo(x + tl, y);
    ctx.lineTo(x + width - tr, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + tr);
    ctx.lineTo(x + width, y + height - br);
    ctx.quadraticCurveTo(x + width, y + height, x + width - br, y + height);
    ctx.lineTo(x + bl, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - bl);
    ctx.lineTo(x, y + tl);
    ctx.quadraticCurveTo(x, y, x + tl, y);
    ctx.closePath();
  }

  onChangeUploadFile(event: any, fileControl: string, imageId: string): void {
    const file = event.target.files[0];
    if (file && file.size <= 10485760) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e: ProgressEvent<FileReader>) => {
        const result = (e.target as FileReader).result as string;

        const index = parseInt(fileControl.replace('fileImage', ''), 10);

        this.files[fileControl] = file;

        this.originalOverlayImages[index] = result; // Save original upload
        this.processedOverlayImages[index] = '';     // Reset processed when new upload
        this.useProcessedImage[index] = false;        // Default to original

        this.createSetUpForm.get(fileControl)?.setValue(result);

        this.setOverlay(index);
      };
    } else {
      this.toastrService.showErrorToast("10Mb Max File Size..");
    }
  }

  setOverlay(index: number) {
    this.selectedOverlayIndex = index;

    setTimeout(() => {
      const container = this.productImageContainer.nativeElement.getBoundingClientRect();
      const cakeType = this.selectedProduct?.product_Code || this.customizePhotoCakes[0];

      const { width, height, offsetTop, offsetLeft } = this.getOverlaySizeAndOffset(
        cakeType,
        container.width,
        container.height,
        this.selectedProduct
      );
      this.overlaySize = { width, height };

      this.overlayPosition = {
        top: (container.height - height) / 2 + offsetTop,
        left: (container.width - width) / 2 + offsetLeft
      };

      // New: right-side overlay position
      if (this.selectedProduct.product_Name.includes('Small')) {
        this.rightOverlaySize = {
          width: container.width * 0.13,
          height: container.height * 0.19
        };

        this.rightOverlayPosition = {
          top: container.height * 0.26,
          left: container.width * 0.77
        };
      } else {
        this.rightOverlaySize = {
          width: container.width * 0.19,
          height: container.height * 0.29
        };

        this.rightOverlayPosition = {
          top: container.height * 0.19,
          left: container.width * 0.71
        };
      }

      this.setRightOverlay();

      this.isCircle = this.customizePhotoCakes.includes(cakeType) &&
        ![this.customizePhotoCakes[3], this.customizePhotoCakes[4], this.customizePhotoCakes[5]].includes(cakeType) &&
        this.selectedProduct?.customizeType !== 'Chocolate';

    }, 0);
  }

  getOverlaySizeAndOffset(cakeType: number, containerWidth: number, containerHeight: number, product?: Product) {
    if (product?.customizeType === 'Chocolate') {
      if (product.product_Name.includes('Small')) {
        return {
          width: containerWidth * 0.33,
          height: containerHeight * 0.46,
          offsetTop: containerWidth * 0.038,
          offsetLeft: containerWidth * -0.08
        };
      }
      else if (product.product_Name.includes('Large')) {
        return {
          width: containerWidth * 0.395,
          height: containerHeight * 0.65,
          offsetTop: containerWidth * 0.060,
          offsetLeft: containerWidth * -0.14
        };
      }
    }

    switch (cakeType) {
      case this.customizePhotoCakes[0]: // Mini
        return { width: containerWidth * 0.50, height: containerWidth * 0.50, offsetTop: -15, offsetLeft: -2 };
      case this.customizePhotoCakes[1]: // Medium
        return { width: containerWidth * 0.60, height: containerWidth * 0.60, offsetTop: -18, offsetLeft: -2 };
      case this.customizePhotoCakes[2]: // Large
        return { width: containerWidth * 0.70, height: containerWidth * 0.70, offsetTop: -8, offsetLeft: -1 };
      case this.customizePhotoCakes[3]: // Classic Frame
        return { width: containerWidth * 0.36, height: containerWidth * 0.44, offsetTop: 13, offsetLeft: 5 };
      case this.customizePhotoCakes[4]: // Modern Frame
        return { width: containerWidth * 0.36, height: containerWidth * 0.69, offsetTop: 23, offsetLeft: -1 };
      case this.customizePhotoCakes[5]: // Landscape Frame
        return { width: containerWidth * 0.56, height: containerWidth * 0.45, offsetTop: 15, offsetLeft: 1 };
      default:
        return { width: containerWidth * 0.5, height: containerWidth * 0.5, offsetTop: 0, offsetLeft: 0 };
    }
  }

  getStyleForImage(index: number) {
    return {
      top: `${this.overlayPosition.top}px`,
      left: `${this.overlayPosition.left}px`,
      width: `${this.overlaySize.width}px`,
      height: `${this.overlaySize.height}px`
    };
  }

  getStyleForRightImage(index: number) {
    return {
      top: `${this.rightOverlayPosition.top}px`,
      left: `${this.rightOverlayPosition.left}px`,
      width: `${this.rightOverlaySize.width}px`,
      height: `${this.rightOverlaySize.height}px`
    };
  }


  overlaySizeRight = { width: 0, height: 0 };
  overlayPositionRight = { top: 0, left: 0 };
  overlaySizeRightSmall = { width: 0, height: 0 };
  overlayPositionRightSmall = { top: 0, left: 0 };

  setRightOverlay() {
    const container = this.productImageContainer.nativeElement.getBoundingClientRect();
    const { width, height, offsetTop, offsetLeft } = this.getOverlaySizeAndOffsetRight(container.width, container.height);

    this.overlaySizeRight = {
      width: width,
      height: height
    };

    this.overlayPositionRight = {
      top: (container.height - height) / 2 + offsetTop,
      left: (container.width - width) / 2 + offsetLeft
    };

    if (this.selectedProduct?.product_Name.includes('Small')) {
      this.overlaySizeRightSmall = {
        width: container.width * 0.15,
        height: container.height * 0.186
      };

      this.overlayPositionRightSmall = {
        top: container.height * 0.28,
        left: container.width * 0.67
      };
    } else {
      this.overlaySizeRightSmall = {
        width: container.width * 0.22,
        height: container.height * 0.20
      };

      this.overlayPositionRightSmall = {
        top: container.height * 0.26,
        left: container.width * 0.66
      };
    }
  }

  getOverlaySizeAndOffsetRight(containerWidth: number, containerHeight: number) {
    if (this.selectedProduct?.product_Name.includes('Small')) {
      return {
        width: containerWidth * 0.39,
        height: containerHeight * 0.378,
        offsetTop: containerWidth * 0.022,
        offsetLeft: containerWidth * -0.228
      };
    } else {
      return {
        width: containerWidth * 0.40,
        height: containerHeight * 0.378,
        offsetTop: containerWidth * 0.00,
        offsetLeft: containerWidth * -0.238
      }
    }
    // return {
    //   width: containerWidth * 0.45,
    //   height: containerHeight * 0.36,
    //   offsetTop: containerWidth * -0.287,
    //   offsetLeft: containerWidth * 0.115
    // };
  }

  getStyleForImageRight(index: number) {
    return {
      top: `${this.overlayPositionRight.top}px`,
      left: `${this.overlayPositionRight.left}px`,
      width: `${this.overlaySizeRight.height}px`,
      height: `${this.overlaySizeRight.width}px`,
      // transform: 'rotate(-90deg)',
      transformOrigin: 'center center'
    };
  }

  getStyleForImageRightSmall(index: number) {
    return {
      top: `${this.overlayPositionRightSmall.top}px`,
      left: `${this.overlayPositionRightSmall.left}px`,
      width: `${this.overlaySizeRightSmall.height}px`,
      height: `${this.overlaySizeRightSmall.width}px`,
      // transform: 'rotate(-90deg)',
      transformOrigin: 'center center'
    };
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.setOverlay(this.selectedOverlayIndex);
  }

  getFixedTopStyle(index: number): any {
    const positions = [
      { left: '33%', top: '15%', transform: 'rotate(18deg)' },
      { left: '45%', top: '19%', transform: 'rotate(6deg)' },
      { left: '56%', top: '16%', transform: 'rotate(-4deg)' }
    ];
    return positions[index] || {};
  }

  getPhotoCircleTopStyle(index: number): any {
    const positions = [
      { top: '19%', left: '28%', transform: 'rotate(-34deg)', 'z-index': 3 },
      { top: '17%', left: '40%', transform: 'rotate(0deg)', 'z-index': 4 },
      { top: '7%', left: '35%', transform: 'rotate(8deg)', 'z-index': 2 },
      { top: '11%', left: '23%', transform: 'rotate(-335deg)', 'z-index': 1 }
    ];
    return positions[index] || {};
  }

  getPhotoCircleMiddleStyle(index: number): any {
    const positions = [
      { top: '57%', left: '22%', width: '17%', height: '20%', transform: 'rotateY(-50deg) scale(0.9)' },
      { top: '60%', left: '35%', width: '15%', height: '21%', transform: 'rotateY(10deg)' },
      { top: '60%', left: '48%', width: '18%', height: '21%', transform: 'rotateY(-40deg)' },
      { top: '57%', left: '58%', height: '22%', width: '20%', transform: ' rotateY(-70deg) scale(0.9)' }
    ];
    return positions[index] || {};
  }

  processedOverlayImages: { [key: number]: string } = {};
  useProcessedImage: { [key: number]: boolean } = {};
  originalOverlayImages: { [key: number]: string } = {};

  async removeBackground(index: number) {
    const base64Data = this.originalOverlayImages[index]; // Always use original image as source

    if (!base64Data) return;

    const file = this.base64ToFile(base64Data, `upload_${index}.png`);

    this.productService.removeImageBackground(file).subscribe({
      next: (blob: Blob) => {
        const reader = new FileReader();
        reader.onload = () => {
          const processedResult = reader.result as string;
          this.processedOverlayImages[index] = processedResult;
          this.useProcessedImage[index] = true;

          // Update form with processed image
          this.createSetUpForm.get('fileImage' + index)?.setValue(processedResult);
        };
        reader.readAsDataURL(blob);
      },
      error: (err) => {
        console.error('Background removal failed:', err);
      }
    });
  }

  base64ToFile(base64: string, filename: string): File {
    const arr = base64.split(',');
    const mime = arr[0].match(/:(.*?);/)?.[1] || '';
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  backToOriginal(index: number) {
    this.useProcessedImage[index] = false;
    const originalImage = this.originalOverlayImages[index];
    this.createSetUpForm.get('fileImage' + index)?.setValue(originalImage);
  }

  getOverlayImage(index: number): string {
    return this.useProcessedImage[index] && this.processedOverlayImages[index]
      ? this.processedOverlayImages[index]
      : this.getFileData('fileImage' + index);
  }

  toggleImageVersion(index: number) {
    if (this.useProcessedImage[index]) {
      // Switch back to original
      this.backToOriginal(index);
    } else {
      // Request background removal
      this.removeBackground(index);
    }
  }

  textInputsTop: { [key: number]: string } = {};
  textInputsBottom: { [key: number]: string } = {};
  textColorTop: { [key: number]: string } = {};
  textColorBottom: { [key: number]: string } = {};
  textFontTop: { [key: number]: string } = {};
  textFontBottom: { [key: number]: string } = {};

  availableFonts = ['Arial', 'Times New Roman', 'Comic Sans MS', 'Pacifico', 'Lobster', 'Dancing Script', 'Great Vibes', 'Amatic SC', 'Satisfy', 'Indie Flower', 'Abril Fatface'
  ];

  getTopTextStyle() {
    if (this.selectedProduct?.product_Name?.includes('Large')) {
      return {
        left: '36%',
        top: '18%',
        color: this.textColorTop[this.selectedOverlayIndex] || 'white',
        fontFamily: this.textFontTop[this.selectedOverlayIndex] || 'Arial'
      };
    }
    return {
      left: '42%',
      top: '25%',
      color: this.textColorTop[this.selectedOverlayIndex] || 'white',
      fontFamily: this.textFontTop[this.selectedOverlayIndex] || 'Arial'
    };
  }

  getBottomTextStyle() {
    if (this.selectedProduct?.product_Name?.includes('Large')) {
      return {
        left: '36%',
        bottom: '19%',
        color: this.textColorBottom[this.selectedOverlayIndex] || 'white',
        fontFamily: this.textFontBottom[this.selectedOverlayIndex] || 'Arial'
      };
    }
    return {
      left: '42%',
      bottom: '25%',
      color: this.textColorBottom[this.selectedOverlayIndex] || 'white',
      fontFamily: this.textFontBottom[this.selectedOverlayIndex] || 'Arial'
    };
  }

  download() {
    this.customizeDetailsSubcription = this.productService.downloada3(this.apiFactory.downloada3, 'Photo Circle_0_1749281309549.jpg').subscribe((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'wrapper_grid_a3.pdf';
      a.click();
      window.URL.revokeObjectURL(url);
    });

  }

  zoomEnabled = false; // toggle state
  zoomScale = 2;
  zoomStyles: { [klass: string]: any } = {};

  toggleZoom(): void {
    this.zoomEnabled = !this.zoomEnabled;
    if (!this.zoomEnabled) this.onMouseLeave(); // reset zoom
  }

  onMouseMove(event: MouseEvent): void {
    this.applyZoom(event.clientX, event.clientY, event.currentTarget as HTMLElement);
  }

  onTouchStart(event: TouchEvent): void {
    if (event.touches.length === 1) {
      event.preventDefault(); // ⬅️ Prevent scrolling
      const touch = event.touches[0];
      this.applyZoom(touch.clientX, touch.clientY, event.currentTarget as HTMLElement);
    }
  }

  onTouchMove(event: TouchEvent): void {
    if (event.touches.length === 1) {
      event.preventDefault(); // ⬅️ Prevent scrolling
      const touch = event.touches[0];
      this.applyZoom(touch.clientX, touch.clientY, event.currentTarget as HTMLElement);
    }
  }


  onMouseLeave(): void {
    this.zoomStyles = {
      transform: 'scale(1)',
      'transform-origin': 'center center',
      transition: 'transform 0.2s ease'
    };
  }

  private applyZoom(clientX: number, clientY: number, container: HTMLElement): void {
    const rect = container.getBoundingClientRect();
    const xPercent = ((clientX - rect.left) / rect.width) * 100;
    const yPercent = ((clientY - rect.top) / rect.height) * 100;

    this.zoomStyles = {
      transform: `scale(${this.zoomScale})`,
      'transform-origin': `${xPercent}% ${yPercent}%`,
      transition: 'transform 0.2s ease'
    };
  }


}
